<template>
  <div id="app-base-file" @dragenter.prevent="dragEnter" @dragover.prevent @dragleave.prevent="dragLeave" @drop.prevent="onDropFile">
    <!-- 拖拽文件到窗口：松手即发送图片/文件 -->
    <div class="drop-mask" v-if="dragCount > 0">
      <div class="drop-mask-text">松开发送图片 / 文件</div>
    </div>
    <div class="header">
      <div class="header-action">
        <div class="min-box" v-if="this.$ipc">
          <div class="min" @click="min(1)"></div>
        </div>
        <div class="min-box" v-if="this.$ipc">
          <div class="max" @click="min(3)"></div>
        </div>
        <div class="min-box-right" v-if="this.$ipc">
          <div class="close-right" @click="min(2)"></div>
        </div>
      </div>
      <div class="title">
        <div class="title-text">{{ fromName }} <img v-show="fromNameZ" width="15px" height="15px" src="@/assets/zicon.png" /></div>
        <div class="more" @click="cheoosInfos"></div>
      </div>
    </div>
    <div style="height: calc(100% - 75px); width: 100%; display: flex">
      <!-- min-width:0 必须加：flex 子项默认 min-width:auto，内部长内容(不可断行数字串等)
           会撑住最小宽度拒绝收缩，导致右侧 260px 扩展栏被推出窗外显示不全 -->
      <div style="height: 100%; width: 100%; min-width: 0; overflow: hidden; position: relative">
        <div class="message" id="message" ref="mianscroll" @scroll="orderscrollEvent">
          <ul v-if="menuVisible" class="context-menu" :style="menuStyle">
            <li v-if="pressItemTo.messageType == 'txt'" @click="menuItemClicked('copy')"><image src="https://cdn.binliyoujia.com/static/message/copy-pc.png"></image>复制</li>
            <li v-if="pressItemTo.messageType != 'audio' && pressItemTo.messageType != 'custom' " @click="menuItemClicked('forward')"><image src="https://cdn.binliyoujia.com/static/message/forward-pc.png"></image>转发</li>
            <li @click="menuItemClicked('quote')"><image src="https://cdn.binliyoujia.com/static/message/quote-pc.png"></image>引用</li>
            <li @click="menuItemClicked('select')"><image src="https://cdn.binliyoujia.com/static/message/select-pc.png"></image>多选</li>
            <li v-if="getIsGoBack()" @click="menuItemClicked('back')"><image src="https://cdn.binliyoujia.com/static/message/back-pc.png"></image>撤回</li>
            <li v-if="canAddToReference(pressItemTo)" @click="menuItemClicked('addimg')"><image src="https://cdn.binliyoujia.com/static/message/addimg-pc.png"></image>添加至参考图库</li>
          </ul>
          <div class="message-box" v-for="item in MessageList" :key="'message' + item.id" :id="'message' + item.id"  @click.stop="setMessageItem(item)">
            <!-- 消息 -->
              <messageBodyList :item="item" @setValues="setValues" @openMenu="openMenu" @openDemand="openDemand" :isMore="isMore" @setForwardItem="setForwardItem" @openForwardMessageListDailogByList="openForwardMessageListDailogByList" @goToQuoteMessage="goToQuoteMessage" @openReadDetail="openReadDetail"></messageBodyList>
          </div>
          <a-spin v-if="islond" />
        </div>
        <!-- 转发扩展弹窗 -->
        <div class="forward-plant" v-if="showForwrad">
          <div class="forward-item" @click="openForwardDailog(0)">
            <img class="z-forward-pc" src="https://cdn.binliyoujia.com/static/message/z-forward-pc.png" />
            <div class="forward-txt">逐条转发</div>
          </div>
          <div class="forward-item" @click="openForwardDailog(1)">
            <img class="h-forward-pc" src="https://cdn.binliyoujia.com/static/message/h-forward-pc.png" />
            <div class="forward-txt">合并转发</div>
          </div>
          <div class="forward-item" :class="{ 'forward-item-disabled': !hasDownloadableSelected }" @click="batchDownload">
            <img class="down-pc" :src="batchDownloadIcon" />
            <div class="forward-txt">批量下载</div>
          </div>
          <div class="forward-item" @click="closeForward">
            <img class="close-pc" src="https://cdn.binliyoujia.com/static/message/close-pc.png" />
          </div>
        </div>

        <!-- 引用扩展弹窗 -->
        <div class="quote-plant" v-if="showQuote" :style="quoteStyle">
          <div class="quote-text">
            <div>{{ getMessageFromMemberName() }}:</div>
            <div style="display: flex; font-weight: 500;" v-if="pressItem.messageType == 'txt'">{{ pressItem.messageMsg }}</div>
            <div style="display: flex; align-items:center;" v-if="pressItem.messageType == 'audio'">[语音]{{ pressItem.messageAudioLength }}"</div>
            <div style="display: flex; align-items:center" v-if="pressItem.messageType == 'img'"><img style="max-height: 56px;margin-right:10px;" :src="pressItem.messageUrl" /></div>
            <div style="display: flex; align-items:center" v-if="pressItem.messageType == 'file'"><img style="max-height: 32px; width: 32rpx;margin-right:10px;" :src="getimage(pressItem.messageFileName)" />{{ pressItem.messageFileName }}</div>
            <div style="display: flex; align-items:center" v-if="pressItem.messageType == 'video'">[视频]<img style="max-height: 56px;margin-right:10px;" :src="pressItem.videoUrl" /></div>
            <div style="display: flex; align-items:center" v-if="pressItem.messageType == 'custom'">[订单消息]</div>
          </div>
          <div @click="closequote">
            <img style="width: 16px; height: 16px" src="https://cdn.binliyoujia.com/static/message/quote-close.png" />
          </div>
        </div>
        <!-- 输入面板 -->
        <div class="intext-tuo" id="intextTuo" @mousedown="down" @mouseup="up" v-if="!showForwrad">
          <div class="intext" @mousedown.stop="" @mouseup.stop="up">
            <div class="intext-action">
              <div class="left-action">
                <div class="bq" @click="openEmo"></div>
                <div class="tp" @click="cheoosImage"></div>
                <div class="wj" @click="cheoosfile"></div>
                <div class="ls" @click="cheoosHistory"></div>
                <div class="yy" @click="openViode"></div>
                <button v-if="canShowVoiceCall()" class="voice-call-entry" type="button" title="语音通话" aria-label="语音通话" @click="openPrivateCall">
                  <svg class="voice-call-icon" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6A19.79 19.79 0 0 1 2.12 4.18 2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.8a2 2 0 0 1-.45 2.11L8.09 13.1a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.84.57 2.8.7A2 2 0 0 1 22 16.92z"></path>
                  </svg>
                </button>
                <div class="sp" @click="SendViode"></div>
              </div>
              <div class="right-action">
                <div class="right-action-inner">
                  <div @click="openReferenceGallery" class="yqtext">
                    <div class="ck"></div>
                    <div>参考图库</div>
                  </div>
                  <div @click="sendCsRate" class="yqtext">
                    <div>评价</div>
                  </div>
                  <div @click="openOrders" class="yqtext">
                    <div class="yq"></div>
                    <div>邀请下单</div>
                  </div>
                  <div class="order" @click="cheoosExts" title="扩展栏"></div>
                </div>
              </div>
            </div>
            <div class="inputbox">
              <textarea ref="editable" @input="changeInputText" @paste="onPasteImage" @keyup.enter="sendTextMessage" onkeydown="if (event.keyCode === 13) event.preventDefault();" v-model="textContent" class="chat_content_editable" spellcheck="false" contenteditable="true" placeholder="请输入消息内容..."> </textarea>
              <button class="send-button" @click="sendTextMessage">发送</button>
            </div>
          </div>
        </div>

        <!-- 表情扩展栏 -->
        <a-modal title="" style="bottom: 20px" v-model="emoVisible" :closable="false" :dialogStyle="dialogStyle" :footer="null" width="274px" height="274px">
          <div class="emobox">
            <div v-for="(item, index) in emojis" :key="index" class="emoitem" @click="addOneEmoji(item)">
              <img class="emoitemimg" :src="getEmimgF(item)" />
            </div>
          </div>
        </a-modal>
        <!-- @扩展栏 -->
        <a-modal title="" style="bottom: 20px" v-model="popupShowBe" :closable="false" :dialogStyle="dialogBeStyle" :footer="null" width="200px">
          <div class="groupMembersBox">
            <div v-for="(item, index) in groupMembers" :key="index" class="groupMembers" @click="setBe(item)">
              {{item.nickname}}
            </div>
          </div>
        </a-modal>

        <!-- 文件上传组件 -->
        <input ref="uploadImgs" type="file" multiple style="display: none" accept="image/*" @change="sendImagesMessage('common')" />
        <input ref="uploadFiles" type="file" style="display: none" single @change="sendFilesMessages" />
        <input ref="uploadVideo" type="file" style="display: none" single @change="sendVideoMessages" />

        <!-- 录音框 -->
        <CollectAudio v-if="isShowRecordBox" @sendAudioMessages="sendAudioMessages" @backAudio="backAudio" />
      </div>

      <!-- 图片预览框 -->
      <a-modal title="" class="imgdialog" style="bottom: 20px" v-model="imgVisible" :closable="false" :footer="null" width="960px" height="640px">
        <div class="imgheader">
          <div class="imgtitle">图片预览</div>
          <div class="imgtitleaction">
            <div class="close" style="margin-top: 5px; margin-right: 0px" @click="minimg()"></div>
          </div>
        </div>
        <div class="imgbox">
          <img :src="preimgurl" draggable="true" :style="{ transform: 'scale(' + multiples + ')' }" @dragstart="dragstart($event)" @dragend="dragend($event)" />
        </div>
        <div class="imgaction">
          <a href="#" style="margin-left: 10px" @click="sximg"><img src="@/assets/suoxiao.png" /></a>
          <a href="#" style="margin-left: 10px" @click="pfimg"><img src="@/assets/fangda.png" /></a>
          <a :href="preimgurl" style="margin-left: 10px" download><img src="@/assets/xiazai.png" /></a>
        </div>
      </a-modal>
      

      
      <!-- 转发详情列表 -->
      <a-modal title="" class="forward-message-list" :body-style="forwardbBody2" style="bottom: 20px" v-model="forwardMessageListDailog" :closable="false" :footer="null" width="840px" height="570px">
        <div class="f-m-title">
          <div class="f-m-t-text">{{ forwardMessageTitle }}</div>
          <img @click="closeForwardMessageListDailog" class="close-pc" src="https://cdn.binliyoujia.com/static/message/close-pc.png" />
        </div>
        <div class="f-m-time">
          {{ consoleTime }}
        </div>
        <div class="f-m-list">
          <div class="f-m-item" v-for="item in dataMessageList" :key="item.id">
            <div class="f-m-i-title">
              <div class="f-m-i-t-text" v-if="item.belong">{{ getMemberName(item) }}</div>
              <div class="f-m-i-t-text" v-if="!item.belong">{{ getMemberName(item) }}</div>
              <div class="f-m-i-t-time">{{ dateFormater(item.createTime) }}</div>
            </div>
            <div class="f-m-i-body">
              <messageBodyListPlant :item="item" @openForwardMessageListDailogByList="openForwardMessageListDailogByList"></messageBodyListPlant>
            </div>
          </div>
        </div>
      </a-modal>

      <!-- 查看需求提示框 -->
      <a-modal title="" v-model="showDemandPlant" style="bottom: 20px" :closable="false" :footer="null" width="540px" height="368px">
        <div class="imgheader-order  demand-body" style="margin-top:0px;">
          <div class="imgtitle-order" style="font-size:16px;font-weight:bold;">需求详情</div>
          <div class="imgtitleaction">
            <div class="close-order" style="margin-top: 16px; margin-right: 0px" @click="closeDemandPlant()"></div>
          </div>
        </div>
        <div class="imgheader-order demand-body" style="height: 368px; overflow: auto;" v-if="demandDetail">
          <div class="demand-item">
              <div class="demand-title">服务类型</div>
              <div class="demand-desc">{{demandDetail.type == 2?'家装':'工装'}}</div>
          </div>
          <div class="demand-item">
              <div class="demand-title">身份类型</div>
              <div class="demand-desc">{{demandDetail.userType == 0?'个人业主':'装修公司'}}</div>
          </div>
          <div class="demand-item">
              <div class="demand-title">小区名称</div>
              <div class="demand-desc">{{demandDetail.name}}</div>
          </div>
         
          <div class="demand-item" v-if="demandDetail.type == 2">
              <div class="demand-title">我的房型</div>
              <div class="demand-desc">{{getHoseName(demandDetail)}}</div>
          </div>
          <div class="demand-item" v-if="demandDetail.type == 2">
              <div class="demand-title">风格偏好</div>
              <div class="demand-desc">{{getStyleName(demandDetail)}}</div>
          </div>
          <div class="demand-item" v-if="demandDetail.type == 1">
              <div class="demand-title">空间类型</div>
              <div class="demand-desc">{{getSpaceName(demandDetail)}}</div>
          </div>
          <div class="demand-item" v-if="demandDetail.area">
              <div class="demand-title">房屋面积</div>
              <div class="demand-desc">{{demandDetail.area}}㎡</div>
          </div>
          <div class="demand-item"  v-if="demandDetail.outPicDate">
              <div class="demand-title">期望出图日期</div>
              <div class="demand-desc">{{demandDetail.outPicDate}}</div>
          </div>
          <div class="demand-line"></div>
          <div class="demand-item" style="display: block;" v-if="demandDetail.housePicUrls">
              <div class="demand-desc">户型图</div>
              <div class="demand-image"><previewImage style="width: 100%; margin-top: 16px; border-radius: 8px; border:1px solid #eee;" :src="itemImage" v-for="(itemImage,imgIndex) in demandDetail.housePicUrls.split(',')" :key="imgIndex"/></div>
          </div>
          <div class="demand-item" style="display: block;" v-if="demandDetail.referencePicUrls">
              <div class="demand-desc">参考图</div>
              <div class="demand-image"><previewImage style="width: 100%; margin-top: 16px;" :src="itemImage" v-for="(itemImage,imgIndex) in demandDetail.referencePicUrls.split(',')" :key="imgIndex"/></div>
          </div>
          <div class="demand-item" style="display: block;" v-if="demandDetail.demandPros">
              <div class="demand-desc">需求信息</div>
              <div class="demand-tab">
                  <div @click="setArrList(item)" class="demand-tab-item" :class="demandDetail.houseIndexId == item.id?'active':''" v-for="(item,index) in demandDetail.demandPros" :key="index">{{item.name}}</div>
              </div>
              <div class="demand-body">
                  <div class="demand-body-item" v-for="(item,index) in spaceDetailArrList" :key="index">
                      <div style="color:#666;">{{item.name}}</div>
                      <div v-for="(dma,dmai) in item.dmarr" :key="dmai" style="margin-left:12px;display: flex; align-items: center; color:#222;">{{dma.name}}
                        <div v-for="(sa,sai) in dma.sarr" :key="sai" style="margin-left:12px;display: flex; align-items: center; color:#666;"><img style="width:12px;height: 8px;margin-right:12px;" src="https://cdn.binliyoujia.com/newstatic/images/jt.png"> {{sa.name}}
                          <div v-for="(sma,smai) in sa.smarr" :key="smai" style="margin-left:12px;color:#222;">{{sma.name}}</div>
                        </div>
                      </div>
                  
                  </div>
              </div>
          </div>
          <div class="demand-line" v-if="demandDetail.demandPros"></div>
          <div class="demand-item" v-if="demandDetail.content">
              <div class="demand-title">需求补充</div>
              <div class="demand-desc">{{demandDetail.content}}</div>
          </div>
        </div>
        <div class="right-foot" style="height: 25px; border: none">
          <div class="right-foot-button" @click="sendDemandOrder" >创建需求</div>
        </div>
      </a-modal>


      <!-- 发送图片提示框 -->
      <a-modal title="" v-model="showImagePlant" style="bottom: 20px" :closable="false" :footer="null" width="540px" height="368px">
        <div class="imgheader-order">
          <div class="imgtitle-order">是否发送图片</div>
          <div class="imgtitleaction">
            <div class="close-order" style="margin-top: 16px; margin-right: 0px" @click="closeImagePlant()"></div>
          </div>
        </div>
        <div class="imgheader-order">
          <div style="height: 200px; padding: 20px">
            <img style="height: 100px; width: 100px" :src="fileBase64" />
          </div>
        </div>
        <div class="right-foot" style="height: 25px; border: none">
          <div class="right-foot-button" @click="sendImageSum">发送</div>
        </div>
      </a-modal>

      <!-- 文件发送提示框 -->
      <a-modal title="" v-model="showFilePlant" style="bottom: 20px" :closable="false" :footer="null" width="540px" height="368px">
        <div class="imgheader-order">
          <div class="imgtitle-order">是否发送文件</div>
          <div class="imgtitleaction">
            <div class="close-order" style="margin-top: 16px; margin-right: 0px" @click="closeFilePlant()"></div>
          </div>
        </div>
        <div class="imgheader-order">
          <div style="height: 200px; padding: 20px">
            <div>文件名称：{{ fileObj ? fileObj.name : '' }}</div>
          </div>
        </div>
        <div class="imgheader-order">
          <div class="right-foot-button" @click="sendImageSum">发送</div>
        </div>
      </a-modal>
      <!-- 右侧扩展栏 -->
      <CollectInfos v-if="isShowInfos" class="history" :uid="userId" :chatType="type" @updateInfos="updateInfos" />
      <!-- 右侧扩展栏 -->
      <CollectExts v-if="isShowExts" class="history" :uid="userId" :chatType="type" @updateInfos="updateInfos" @gotoGroup="gotoGroup" @backCy="backCy" @onBackZdy="onBackZdy" @onBackZj="onBackZj" />
      <!-- 历史消息 -->
      <a-modal title="" v-model="isShowHistory" style="bottom: 20px" :closable="false" :footer="null" width="540px" height="368px">
        <CollectHistory v-if="isShowHistory" class="history" style="border: none; width: auto" :uid="itemId" :chatType="type" @updateInfos="updateInfos" @closemin="closemin" />
      </a-modal>
      <!-- 邀请下单框 -->
      <a-modal title="" class="imgdialog-order" style="bottom: 20px" v-model="ProructVisible" :closable="false"  :footer="null" width="720px">
        <InviteOrder :userId="userId" :type="type" :identityType="memberIdentityType" @close="closeInviteOrder" :demandId="demandId"></InviteOrder>
      </a-modal>
      <a-modal title="" v-model="readDetailVisible" :footer="null" width="420px" :closable="true">
        <div class="rd-title">消息详情</div>
        <div class="rd-card" v-if="readDetailItem">
          <img class="rd-avatar" :src="readFromAvatar" />
          <div class="rd-card-main">
            <div class="rd-row">
              <span>{{ readFromName }}</span>
              <span class="rd-time">{{ dateFormater(readDetailItem.createTime) }}</span>
            </div>
            <div class="rd-msg">{{ readDetailText }}</div>
          </div>
        </div>
        <div class="rd-tabs">
          <div :class="readDetailTab===0?'rd-tab on':'rd-tab'" @click="readDetailTab=0">{{ readMembers.length }}人已读<div v-if="readDetailTab===0" class="rd-line" /></div>
          <div :class="readDetailTab===1?'rd-tab on':'rd-tab'" @click="readDetailTab=1">{{ unreadMembers.length }}人未读<div v-if="readDetailTab===1" class="rd-line" /></div>
        </div>
        <div class="rd-list">
          <div v-for="m in (readDetailTab===0?readMembers:unreadMembers)" :key="m.id" class="rd-item">
            <img :src="m.avatar" />
            <span>{{ m.nickname }}</span>
          </div>
        </div>
      </a-modal>

      <!-- 群成员单选语音通话；群成员资格及号码始终由服务端解析 -->
      <a-modal
        v-model="callDialogVisible"
        title="请选择"
        :footer="null"
        width="640px"
        :maskClosable="false"
        :closable="!callLoading"
        :keyboard="!callLoading"
        :body-style="{ maxHeight: '78vh', overflowY: 'auto' }"
      >
        <div class="private-call-panel">
          <a-spin :spinning="callLoading">
            <div v-if="!callLoading && callLoadError" class="private-call-load-error">
              <div>{{ callLoadError }}</div>
              <button class="private-call-primary private-call-retry" type="button" @click="openPrivateCall">重新加载</button>
            </div>
            <div v-else-if="!callLoading && callOrders.length === 0" class="private-call-empty">
              当前项目组暂无可通话成员，请检查有效订单、群成员及成员手机号
            </div>
            <template v-else>
              <div class="private-call-section-title">通话对象<span>*</span></div>
              <div class="private-call-targets">
                <button
                  v-for="target in callTargetOptions"
                  :key="target.key"
                  type="button"
                  :disabled="callLoading"
                  :class="['private-call-target', { active: String(selectedCallCustomerId) === target.key }]"
                  @click="selectCallTarget(target)"
                >
                  <img v-if="target.customerAvatar" :src="target.customerAvatar" class="private-call-target-avatar" />
                  <span v-else class="private-call-target-avatar private-call-target-fallback">{{ target.initial }}</span>
                  <span class="private-call-target-name">{{ target.customerName }}<small v-if="target.customerMobileMasked"> {{ target.customerMobileMasked }}</small></span>
                  <span class="private-call-target-check">✓</span>
                </button>
              </div>

              <div class="private-call-protection">
                <span>号码保护</span>
                <strong>✓ 虚拟号（双方互不可见真实号）</strong>
              </div>

              <div class="private-call-field">
                <div class="private-call-label">关联订单</div>
                <a-select v-if="filteredCallOrders.length > 1" v-model="selectedCallOrderId" :disabled="callLoading" style="min-width: 240px" @change="onCallOrderChanged">
                  <a-select-option v-for="order in filteredCallOrders" :key="order.orderId" :value="order.orderId">{{ order.orderNo || order.orderId }}</a-select-option>
                </a-select>
                <div v-else class="private-call-order-value">
                  {{ selectedCallOrder ? (selectedCallOrder.orderNo || selectedCallOrder.orderId) : '--' }}
                </div>
              </div>

              <div v-if="callBinding && callBinding.id" class="private-call-active">
                <div class="private-call-status">{{ callBinding.autoReleaseStatus ? '通话已结束，等待号码释放' : '已生成本订单通话号码' }}</div>
                <div class="private-call-number">{{ callBinding.xNumber }}</div>
                <div class="private-call-mask">{{ selectedCallTarget ? selectedCallTarget.customerName : '所选成员' }} {{ callBinding.aNumberMasked }} ↔ 当前员工 {{ callBinding.bNumberMasked }}</div>
                <div class="private-call-tip">仅所选成员与当前员工可以使用上方号码通话，不是多人会议。通话结束后由服务器自动释放号码，关闭此窗口不影响自动释放；录音、转写和 AI 分析仍关联本订单。</div>
                <div v-if="callBindingPollError" class="private-call-load-error">{{ callBindingPollError }}</div>
                <div class="private-call-actions">
                  <button class="private-call-primary" type="button" :disabled="!!callBinding.autoReleaseStatus" @click="copyPrivateNumber">复制通话号码</button>
                  <button v-if="callManualReleaseVisible || callBindingPollError" class="private-call-danger" type="button" :disabled="callLoading" @click="releasePrivateCall">手动结束并释放（异常兜底）</button>
                  <button v-else class="private-call-danger" type="button" @click="callManualReleaseVisible = true">号码状态异常？</button>
                </div>
                <div v-if="callManualReleaseVisible" class="private-call-tip">若已挂断但号码长时间未释放，可手动重试。正在通话时请勿操作。</div>
              </div>
              <div v-else-if="selectedCallOrderId" class="private-call-not-active">
                <div v-if="callBindingNotice" class="private-call-status">{{ callBindingNotice }}</div>
                <div class="private-call-tip">系统使用所选群成员和当前员工的已登记号码建立一对一通话映射，双方真实号码不会返回到页面。</div>
                <label class="private-call-consent">
                  <input v-model="callRecordingConsent" type="checkbox" />
                  <span>我已了解并同意通话将被录音，录音用于处理纠纷和安全保障</span>
                </label>
                <div class="private-call-footer">
                  <button class="private-call-danger" type="button" :disabled="callLoading" @click="callDialogVisible = false">取消</button>
                  <button class="private-call-primary private-call-create" type="button" :disabled="callLoading || !callRecordingConsent" @click="createPrivateCall">呼叫</button>
                </div>
              </div>

            </template>
          </a-spin>
        </div>
      </a-modal>
      <!-- 转发消息框 -->
      <a-modal title="" class="forward-dailog" :body-style="forwardbBody" style="bottom: 20px" v-model="forwardDailog" :closable="false" :footer="null" width="472px" height="441px">
        <ForwardDailog :userId="userId" :type="type" :forwardList="forwardList" :fromName="fromName" @close="closeForwardDailog" @closeForward="closeForward" @openForwardMessageListDailog="openForwardMessageListDailog" :forwardMessageTitle="forwardMessageTitle" :forwardSendType="forwardSendType" :forwardType="forwardType"></ForwardDailog>
      </a-modal>
      <div v-show="menuVisible" class="mb" @click="closeMb" ></div>

      <!-- 添加至参考图库 -->
      <AddToReference
        :visible="addToRefVisible"
        :picUrl="addToRefPicUrl"
        @close="addToRefVisible = false"
      />
      <!-- 发送参考图库 -->
      <ReferenceGallery
        :visible="refGalleryVisible"
        @close="refGalleryVisible = false"
        @ok="onReferenceGalleryOk"
      />
    </div>
  </div>
</template>
<script>
import storage from 'store2'
import { ipcApiRoute, requestHttpGet, requestHttpPostByOnline } from '@/api/main'
import emMap from '@/utils/em'
import { emojis } from '@/constant'
import fileSizeFormat from '@/utils/fileSizeFormat'
import _ from 'lodash'
import CollectAudio from '@/components/audio.vue'
import CollectHistory from '@/components/history.vue'
import CollectInfos from '@/components/infos.vue'
import CollectExts from '@/components/exts.vue'
import CollectPj from '@/components/pj.vue'
import CollectOrder from '@/components/order.vue'
import CollectXq from '@/components/xq.vue'
import CollectFa from '@/components/fa.vue'
import CollectGoods from '@/components/goods.vue'

import previewImage from '@/components/elimage.vue'
import apiUrl from '@/utils/config'
import { message } from 'ant-design-vue'
import dateFormaterSession from '@/utils/dateFormaterSession'
import dateFormater from '@/utils/dateFormater'
import messageBodyList from '@/components/messageBodyList/messageBodyList.vue'
import messageBodyListPlant from '@/components/messageBodyList/messageBodyListPlant.vue'

import InviteOrder from '@/components/dailog/inviteOrder.vue'
import ForwardDailog from '@/components/dailog/forwardDailog.vue'
import AddToReference from '@/components/dailog/addToReference.vue'
import ReferenceGallery from '@/components/dailog/referenceGallery.vue'

// 可批量下载的消息类型(与单条下载 v-down 的口径一致：有 messageUrl 即可下载；audio 不提供下载)
const DOWNLOADABLE_MESSAGE_TYPES = ['img', 'file', 'video']
export default {
  components: {
    CollectAudio,
    CollectHistory,
    CollectExts,
    CollectInfos,
    CollectPj,
    CollectOrder,
    CollectXq,
    CollectFa,
    CollectGoods,
    previewImage,
    InviteOrder,
    ForwardDailog,
    AddToReference,
    ReferenceGallery,
    messageBodyList,
    messageBodyListPlant,
  },
  props: {
    uid: {
      type: String,
      default: '',
    },
    pId: {
      type: Number,
      default: 0,
    },
    usId: {
      type: String,
      default: '',
    },
    chatType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      fileBase64: '',
      showImagePlant: false,
      showFilePlant: false,
      loading: false,
      emMap: emMap,
      fromName: '',
      ProructVisible: false,
      readDetailVisible: false,
      readDetailItem: null,
      readDetailTab: 0,
      forwardDailog: false,
      islond: false,
      dragCount: 0,
      multiples: 1,
      textContent: '',
      dialogMessageValue: '',
      forwardMessageListDailog: false,
      oldY: 0,
      flag: false,
      targetDiv: '',
      targetDivHeight: 0,
      MessageList: [],
      // 多选勾选版本号：isSelect 非响应式，批量下载可用态靠它重算
      downloadSelectVersion: 0,
      forwardType: 0,
      username: '',
      emoVisible: false,
      showDemandPlant:false,
      forwardbBody: {
        padding: 0,
        display: 'flex',
        borderRadius: '10px',
      },
      forwardbBody2: {
        padding: 0,
        borderRadius: '10px',
      },
      dialogStyle: {
        top: '100px',
        'margin-left': '280px',
      },
      dialogBeStyle: {
        top: '100px',
        'margin-left': '280px',
      },
      
      emojis: emojis,
      members:[],
      fileObj: null,
      fileSizeFormat: fileSizeFormat,
      isShowRecordBox: false,
      imgVisible: false,
      preimgurl: '',
      initWidth: 0, // 父元素的宽-自适应值
      initHeight: 0, // 父元素的高-自适应值
      startclientX: 0, // 元素拖拽前距离浏览器的X轴位置
      startclientY: 0, //元素拖拽前距离浏览器的Y轴位置
      elLeft: 0, // 元素的左偏移量
      elTop: 0, // 元素的右偏移量
      isShowHistory: false,
      isShowInfos: false,
      isShowExts: false,
      page: -1,
      loadList: [],
      forwardList: [],
      forwardSendType: 0,
      forwardMessageTitle: '',
      cyy: '',

      fromNameZ: false,
      // null=尚未查到对方身份；勿默认 0，否则邀请下单会按个人业主价发出
      memberIdentityType: null,
      orderType: 1,
      seachvalue: '',
      productList: [],
      pageNo: 1,
      pageSize: 25,
      itemId: '',
      userId: '',
      pageId: '',
      type: '',
      hasMore: true,
      menuVisible: false,
      menuStyle: {
        top: 0,
        left: 0,
      },
      pressItem: {},
      isMore: false,
      pressItemTo: {},
      addToRefVisible: false,
      addToRefPicUrl: '',
      refGalleryVisible: false,
      showForwrad: false,
      showQuote: false,
      quoteStyle: {
        bottom: 0,
      },
      forwardSearchValue: '',
      consoleTime: '',
      dataMessageList: [],
      demandDetail:{},
      spaceDetailArrList:[],
      demandId:0,
      stylesList:[],
      spacesList:[],
      housesList:[],
      popupShowBe:false,
      textContentIndex:0,
      groupMembers:[],
      be_ids:[],
      select_m_list:[],
      textSending: false,
      orderSending: false,
      callDialogVisible: false,
      callLoading: false,
      callLoadError: '',
      callLoadSequence: 0,
      callOrders: [],
      selectedCallCustomerId: null,
      selectedCallOrderId: null,
      callBinding: null,
      callBindingPollTimer: null,
      callBindingPollSequence: 0,
      callBindingPollError: '',
      callBindingNotice: '',
      callManualReleaseVisible: false,
      callRecordingConsent: false,
      voiceCallProjectChecked: false,
      voiceCallProjectAvailable: false,
    }
  },
  computed: {
    callTargetOptions() {
      const targets = new Map()
      this.callOrders.forEach(order => {
        const key = this.callTargetKey(order)
        if (targets.has(key)) return
        const name = order.customerName || '订单客户'
        targets.set(key, {
          key,
          targetAccount: order.targetAccount || null,
          customerUserId: order.customerUserId || null,
          customerName: name,
          customerAvatar: order.customerAvatar || '',
          customerMobileMasked: order.customerMobileMasked || '',
          initial: String(name).slice(0, 1),
        })
      })
      return Array.from(targets.values())
    },
    filteredCallOrders() {
      if (this.selectedCallCustomerId === null || this.selectedCallCustomerId === undefined) return []
      const selected = String(this.selectedCallCustomerId)
      return this.callOrders.filter(order =>
        this.callTargetKey(order) === selected)
    },
    selectedCallTarget() {
      const selected = String(this.selectedCallCustomerId)
      return this.callTargetOptions.find(target => target.key === selected) || null
    },
    selectedCallOrder() {
      return this.filteredCallOrders.find(order => String(order.orderId) === String(this.selectedCallOrderId)) || null
    },
    readMembers() {
      const item = this.readDetailItem
      if (!item || !item.members) return []
      return item.members.filter(m => m.id != item.messageFrom && m.isRead)
    },
    unreadMembers() {
      const item = this.readDetailItem
      if (!item || !item.members) return []
      return item.members.filter(m => m.id != item.messageFrom && !m.isRead)
    },
    readFromName() {
      const item = this.readDetailItem
      if (!item || !item.members) return ''
      const m = item.members.find(u => u.id == item.messageFrom)
      return m ? m.nickname : ''
    },
    readFromAvatar() {
      const item = this.readDetailItem
      if (!item || !item.members) return ''
      const m = item.members.find(u => u.id == item.messageFrom)
      return m ? m.avatar : ''
    },
    readDetailText() {
      const item = this.readDetailItem
      if (!item) return ''
      if (item.messageType == 'txt') return item.messageMsg
      if (item.messageType == 'img') return '[图片]'
      if (item.messageType == 'audio') return '[语音]'
      if (item.messageType == 'video') return '[视频]'
      if (item.messageType == 'file') return item.messageFileName || '[文件]'
      if (item.messageType == 'custom') return '[卡片消息]'
      return item.messageMsg || ''
    },
  },
  watch: {
    callDialogVisible(visible) {
      if (visible) this.startCallBindingPolling()
      else this.stopCallBindingPolling()
    },
  },
  mounted() {
    //关闭监听新消息
    this.$bus.$off('im.allChatMessage')
    this.$bus.$off('im.allGroupMessage')
    this.$bus.$off('im.allChatReadMessage')
    this.$bus.$off('im.allBackMessage')
    this.$bus.$off('im.reconnected')
    //监听新消息
    this.$bus.$on('im.allChatMessage', this.newChatMessage)
    this.$bus.$on('im.allGroupMessage', this.newGroupMessage)
    this.$bus.$on('im.allBackMessage', this.updateBackMessage)
    //已读回执
    this.$bus.$on('im.allChatReadMessage', this.readMessage)
    //断线重连成功：补拉当前会话最新消息(断线期间的推送不会补发，必须主动拉)
    this.$bus.$on('im.reconnected', this.handleReconnected)
    this.initDatas()
  },
  destroyed() {
    console.log('销毁')
    this.$bus.$off('im.allChatMessage')
    this.$bus.$off('im.allGroupMessage')
    this.$bus.$off('im.allChatReadMessage')
    this.$bus.$off('im.allBackMessage')
  },
  methods: {
    callTargetKey(order) {
      return String(order.targetAccount || (order.customerUserId ? 'mb_' + order.customerUserId : 'order-' + order.orderId))
    },
    canShowVoiceCall() {
      // 项目组入口固定展示；订单与成员归属仍由后端按当前群 conversationId 严格校验。
      // 这样不会因为预检查、缓存或网络波动把入口本身隐藏掉。
      return this.type === 'group'
    },
    async sendCsRate() {
      if (this.type !== 'chat') {
        message.warning('请在单聊中发送评价')
        return
      }
      if (!this.userId || !this.itemId) {
        message.warning('请先选择会话')
        return
      }
      if (!this.$ImSdk.isImConnected()) {
        message.error('IM 未连接，请检查网络后重试')
        return
      }
      const raw = storage.get('userId') || ''
      const csUserId = Number(String(raw).replace(/^ad_/, '').replace(/^sd_/, ''))
      const obj = {
        type: 'csRate',
        title: '服务评价',
        content: '请对本次客服服务进行评价',
        sessionId: this.itemId,
        csUserId: csUserId
      }
      await this.$ImSdk.sendCustomMessages(this.userId, this.type, obj, this, {}, 0)
      message.success('评价卡片已发送')
    },
    async openPrivateCall() {
      this.stopCallBindingPolling()
      this.callBindingNotice = ''
      this.callBindingPollError = ''
      this.callManualReleaseVisible = false
      const conversationId = String(this.itemId || '')
      const loadSequence = ++this.callLoadSequence
      this.callDialogVisible = true
      this.callOrders = []
      this.selectedCallCustomerId = null
      this.selectedCallOrderId = null
      this.callBinding = null
      this.callRecordingConsent = false
      this.callLoadError = ''
      this.callLoading = true
      try {
        const orders = await this.loadVoiceCallOrders(conversationId)
        if (loadSequence !== this.callLoadSequence || this.type !== 'group'
          || String(this.itemId || '') !== conversationId || !this.callDialogVisible) {
          return
        }
        this.callOrders = orders
        if (this.callOrders.length > 0) {
          this.selectCallTarget(this.callTargetOptions[0])
        } else {
          message.warning('当前项目组暂无可通话成员，请检查群成员、手机号及关联订单')
        }
      } catch (error) {
        if (loadSequence !== this.callLoadSequence || String(this.itemId || '') !== conversationId) {
          return
        }
        this.callLoadError = this.getCallErrorMessage(error, '语音通话订单加载失败')
        message.error(this.callLoadError)
      } finally {
        if (loadSequence === this.callLoadSequence) {
          this.callLoading = false
        }
      }
    },
    async loadVoiceCallOrders(conversationId) {
      const result = await requestHttpGet(apiUrl + '/admin-api/supplier/call/im/order-options', {
        conversationId,
      })
      if (!result || result.code !== 0) {
        throw new Error((result && result.msg) || '订单查询失败')
      }
      return result.data || []
    },
    async refreshVoiceCallAvailability() {
      const conversationId = String(this.itemId || '')
      if (this.type !== 'group' || !conversationId) {
        this.voiceCallProjectChecked = false
        this.voiceCallProjectAvailable = false
        return
      }
      try {
        const orders = await this.loadVoiceCallOrders(conversationId)
        // 快速切换会话时丢弃上一项目组的异步返回，防止按钮串群。
        if (this.type !== 'group' || String(this.itemId || '') !== conversationId) return
        if (!this.callDialogVisible) this.callOrders = orders
        this.voiceCallProjectAvailable = orders.length > 0
      } catch (error) {
        if (this.type !== 'group' || String(this.itemId || '') !== conversationId) return
        this.voiceCallProjectAvailable = false
      } finally {
        if (this.type === 'group' && String(this.itemId || '') === conversationId) {
          this.voiceCallProjectChecked = true
        }
      }
    },
    onCallOrderChanged() {
      this.stopCallBindingPolling()
      this.callBindingNotice = ''
      this.callBindingPollError = ''
      this.callManualReleaseVisible = false
      const order = this.selectedCallOrder
      this.callBinding = order && order.bindingId ? {
        id: order.bindingId,
        status: order.bindingStatus,
        xNumber: order.xNumber,
        aNumberMasked: order.aNumberMasked,
        bNumberMasked: order.bNumberMasked,
      } : null
    },
    selectCallTarget(target) {
      if (!target) return
      this.selectedCallCustomerId = target.key
      const firstOrder = this.filteredCallOrders[0]
      this.selectedCallOrderId = firstOrder ? firstOrder.orderId : null
      this.callRecordingConsent = false
      this.onCallOrderChanged()
    },
    async createPrivateCall() {
      if (this.callLoading) return
      if (!this.selectedCallTarget) {
        message.warning('请先选择通话对象')
        return
      }
      if (!this.selectedCallOrderId) {
        message.warning('当前项目组没有可关联的有效订单')
        return
      }
      if (!this.callRecordingConsent) {
        message.warning('请先确认录音告知')
        return
      }
      this.callLoading = true
      const sequence = this.callLoadSequence
      const conversationId = String(this.itemId || '')
      const selectedOrderId = this.selectedCallOrderId
      const selectedTargetKey = this.selectedCallCustomerId
      try {
        const created = await requestHttpPostByOnline(apiUrl + '/admin-api/supplier/call/im/binding/create', {
          orderId: selectedOrderId,
          memberUserId: this.selectedCallTarget.customerUserId,
          targetAccount: this.selectedCallTarget.targetAccount,
          conversationId,
        })
        if (!created || created.code !== 0 || !created.data) {
          throw new Error((created && created.msg) || '通话号码生成失败')
        }
        const detail = await requestHttpGet(apiUrl + '/admin-api/supplier/call/im/binding/get', { id: created.data })
        if (!detail || detail.code !== 0 || !detail.data) {
          throw new Error((detail && detail.msg) || '通话号码详情查询失败')
        }
        if (sequence !== this.callLoadSequence || String(this.itemId || '') !== conversationId
          || !this.callDialogVisible || this.selectedCallCustomerId !== selectedTargetKey) return
        this.callBinding = detail.data
        this.updateCallOrderBinding(detail.data)
        this.callBindingNotice = ''
        this.callBindingPollError = ''
        this.callManualReleaseVisible = false
        this.startCallBindingPolling()
        message.success('通话号码已生成')
      } catch (error) {
        if (sequence !== this.callLoadSequence || String(this.itemId || '') !== conversationId) return
        message.error(this.getCallErrorMessage(error, '通话号码生成失败'))
      } finally {
        if (sequence === this.callLoadSequence) this.callLoading = false
      }
    },
    async releasePrivateCall() {
      if (this.callLoading) return
      if (!this.callBinding || !this.callBinding.id) {
        return
      }
      if (!window.confirm('确认结束当前语音通话并释放通话号码吗？')) {
        return
      }
      this.callLoading = true
      const sequence = this.callLoadSequence
      const conversationId = String(this.itemId || '')
      try {
        const result = await requestHttpPostByOnline(
          apiUrl + '/admin-api/supplier/call/im/binding/release?id=' + encodeURIComponent(this.callBinding.id), {})
        if (!result || result.code !== 0) {
          throw new Error((result && result.msg) || '号码释放失败')
        }
        if (sequence !== this.callLoadSequence || String(this.itemId || '') !== conversationId) return
        this.updateCallOrderBinding(null)
        this.callBinding = null
        this.callRecordingConsent = false
        this.callBindingNotice = '通话号码已释放，再次通话请重新生成号码。'
        this.callBindingPollError = ''
        this.callManualReleaseVisible = false
        this.stopCallBindingPolling()
        message.success('通话号码已释放')
      } catch (error) {
        if (sequence !== this.callLoadSequence || String(this.itemId || '') !== conversationId) return
        message.error(this.getCallErrorMessage(error, '号码释放失败'))
      } finally {
        if (sequence === this.callLoadSequence) this.callLoading = false
      }
    },
    stopCallBindingPolling() {
      this.callBindingPollSequence += 1
      if (this.callBindingPollTimer !== null) clearTimeout(this.callBindingPollTimer)
      this.callBindingPollTimer = null
    },
    startCallBindingPolling() {
      this.stopCallBindingPolling()
      if (!this.callDialogVisible || !this.callBinding || !this.callBinding.id) return
      const sequence = this.callBindingPollSequence
      this.callBindingPollTimer = setTimeout(() => this.pollCallBinding(sequence), 3000)
    },
    async pollCallBinding(sequence) {
      const bindingId = this.callBinding && this.callBinding.id
      const conversationId = String(this.itemId || '')
      const targetKey = this.selectedCallCustomerId
      const isCurrent = () => sequence === this.callBindingPollSequence && this.callDialogVisible
        && String(this.itemId || '') === conversationId && this.selectedCallCustomerId === targetKey
        && this.callBinding && String(this.callBinding.id) === String(bindingId)
      if (!bindingId || !isCurrent()) return
      this.callBindingPollTimer = null
      try {
        // Only the backend, using authenticated provider callbacks, decides whether a call has ended.
        // The browser never releases a number based on a timer or closing this dialog.
        const result = await requestHttpGet(apiUrl + '/admin-api/supplier/call/im/binding/get', { id: bindingId })
        if (!isCurrent()) return
        if (!result || result.code !== 0 || !result.data || String(result.data.id) !== String(bindingId)) {
          throw new Error('号码状态查询失败')
        }
        const binding = result.data
        if (binding.status === 'RELEASED' || binding.status === 'EXPIRED') {
          this.updateCallOrderBinding(null)
          this.callBinding = null
          this.callRecordingConsent = false
          this.callBindingPollError = ''
          this.callManualReleaseVisible = false
          this.callBindingNotice = binding.status === 'EXPIRED'
            ? '通话号码已到期，再次通话请重新生成号码。'
            : '通话已结束，号码已释放；再次通话请重新生成号码。'
          this.stopCallBindingPolling()
          return
        }
        this.callBinding = binding
        this.updateCallOrderBinding(binding)
        this.callBindingPollError = binding.autoReleaseStatus === 'FAILED'
          ? '通话已结束，自动释放暂时失败，服务器会自动重试；也可手动结束并释放。' : ''
      } catch (error) {
        if (!isCurrent()) return
        this.callBindingPollError = '暂时无法更新号码状态，服务器仍会处理自动释放；若已挂断但未释放，可手动重试。'
      } finally {
        // Schedule after the previous request finishes: slow networks cannot stack polling requests.
        if (isCurrent()) this.callBindingPollTimer = setTimeout(() => this.pollCallBinding(sequence), 3000)
      }
    },
    updateCallOrderBinding(binding) {
      const order = this.selectedCallOrder
      if (!order) {
        return
      }
      this.$set(order, 'bindingId', binding ? binding.id : null)
      this.$set(order, 'bindingStatus', binding ? binding.status : null)
      this.$set(order, 'xNumber', binding ? binding.xNumber : null)
      this.$set(order, 'aNumberMasked', binding ? binding.aNumberMasked : null)
      this.$set(order, 'bNumberMasked', binding ? binding.bNumberMasked : null)
      this.$set(order, 'autoReleaseStatus', binding ? binding.autoReleaseStatus : null)
    },
    copyPrivateNumber() {
      if (this.callBinding && this.callBinding.autoReleaseStatus) return
      const value = this.callBinding && this.callBinding.xNumber
      if (!value) {
        return
      }
      const input = document.createElement('textarea')
      input.value = value
      input.style.position = 'fixed'
      input.style.opacity = '0'
      document.body.appendChild(input)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      message.success('通话号码已复制')
    },
    getCallErrorMessage(error, fallback) {
      const status = error && error.response && error.response.status
      if (status === 404) {
        return '语音通话服务暂不可用（HTTP 404），请确认供应商服务已启动并已部署最新后端程序'
      }
      if (status === 502 || status === 503 || status === 504) {
        return `语音通话服务暂不可用（HTTP ${status}），请稍后重试或联系技术人员检查供应商服务`
      }
      if (error && (error.code === 'ECONNABORTED' || /timeout/i.test(error.message || ''))) {
        return '语音通话服务请求超时，请稍后重试'
      }
      if (error && error.response && error.response.data && error.response.data.msg) {
        return error.response.data.msg
      }
      return (error && error.message) || fallback
    },
    setBeAll(){
				this.select_m_list = []
				this.groupMembers.forEach(e=>{
					e.select = true
					this.select_m_list.push(e)
				})
				this.setBean()
		},
    setBe(e){
      this.select_m_list = []
			e.select = !e.select
			this.select_m_list.push(e)
			this.setBean()
    },
    setBean(){
				this.be_ids = []
				const prefix = this.textContentIndex >= 0
					? this.textContent.substring(0, this.textContentIndex)
					: this.textContent
				let mentionText = ''
				this.select_m_list.forEach(m => {
					mentionText += '@' + m.nickname + ' '
				})
				this.textContent = prefix + mentionText
				this.popupShowBe = false
		},
    async initDatas(){
      let data1 = await requestHttpGet(apiUrl + '/admin-api/product/style/list-all-simple',{})
      this.stylesList = data1.data
      let data2 = await requestHttpGet(apiUrl + '/admin-api/product/space/list-all-simple',{})
      this.spacesList = data2.data
      let data3 = await requestHttpGet(apiUrl + '/app-api/system/dict-data/type?type=render_house',{})
      this.housesList = data3.data
     
    },
    async initdata() {
      console.log('你被调用几次？', this.userId)
      this.stopCallBindingPolling()
      this.callBindingNotice = ''
      this.callBindingPollError = ''
      this.callManualReleaseVisible = false
      this.callLoadSequence += 1
      this.callDialogVisible = false
      this.callLoadError = ''
      this.callOrders = []
      this.selectedCallCustomerId = null
      this.selectedCallOrderId = null
      this.callBinding = null
      this.callRecordingConsent = false
      this.voiceCallProjectChecked = false
      this.voiceCallProjectAvailable = false
      this.groupMembers = []
      this.userId = this.usId
      this.itemId = this.uid
      this.pageId = this.pId
      this.type = this.chatType
      this.pageNo = 1
      this.MessageList = []
      await this.getHostList()
      await this.refreshVoiceCallAvailability()
    },
    closeMb() {
      this.menuVisible = false
    },
    closeInviteOrder(){
      this.ProructVisible = false
    },
    dateFormater(v) {
      return dateFormaterSession(v)
    },
    async newChatMessage(e) {
      let that = this
      console.log('收到单聊消息', e)
      console.log('当前会话', that.itemId)
      //判断是否在当前会话
      if (that.itemId == e.messageSessionId) {
        //按消息id去重：发送回执(code100)与消息推送(code50)可能重复到达(双连接/脏members场景)，
        //避免同一条消息在聊天窗重复显示
        if (that.MessageList.some(m => m.id == e.id)) {
          return
        }
        //添加消息
        let body = await that.$ImSdk.getChatMessageBody(e)
        body.createTime = new Date(body.createTime).getTime()
        that.MessageList.push(body)

        if (storage.get('userId') != e.messageFrom) {
           that.$ImSdk.sendReadMessage(body['id'],storage.get('userId'))
        }
        //设置滚动到最新消息
        that.$nextTick(() => {
          //获取最后加载的最有一个div
          let toItem = document.getElementById('message' + body['id'])
          that.scrollToItem(toItem)
        })
      }
    },
    async newGroupMessage(e) {
      let that = this
      console.log('收到群聊消息', e)
      //判断是否在当前会话
      if (this.itemId == e.messageSessionId) {
        //按消息id去重：发送回执(code100)与群消息推送(code1001)可能重复到达，避免重复显示
        if (that.MessageList.some(m => m.id == e.id)) {
          return
        }
        //添加消息
        let body = await this.$ImSdk.getGroupMessageBody(e)
        body.createTime = new Date(body.createTime).getTime()
        that.MessageList.push(body)

        if (storage.get('userId') != e.messageFrom) {
           that.$ImSdk.sendReadMessage(body['id'],storage.get('userId'))
        }
        console.log(body)
        //设置滚动到最新消息
        that.$nextTick(() => {
          //获取最后加载的最有一个div
          let toItem = document.getElementById('message' + body['id'])
          that.scrollToItem(toItem)
        })
      }
    },
    async readMessage(e) {
      console.log('收到已读消息回执', e,this.itemId)
      this.MessageList.forEach(m => {
					if(m.id == e.conversationId){
              m.members.forEach(u=>{
                if (u.id == e.userId) {
                   u.isRead = true
                }
              })
					}
				})
        this.$forceUpdate()
    },
    closeImagePlant() {
      this.showImagePlant = false
    },
    closeFilePlant() {
      this.showFilePlant = false
    },
    closeDemandPlant(){
      this.showDemandPlant = false
    },
    getEmimg(item) {
      if (item.messageMsg.indexOf('[') >= 0) {
        let msgs = item.messageMsg
        //分析出所有表情
        for (const key in this.emMap) {
          if (item.messageMsg.indexOf(key) >= 0) {
            msgs = msgs.replaceAll(key, '<img src="' + require('../assets/faces/' + this.emMap[key]) + '"/>')
          }
        }
        return msgs
      } else {
        return item.messageMsg
      }
    },
    getEmimgF(item) {
      if (item.indexOf('[') >= 0) {
        return 'https://cdn.binliyoujia.com/static/im/faces/' + this.emMap[item]
      } else {
        return item
      }
    },
    sximg() {
      if (this.multiples <= 1) {
        return
      }
      this.multiples -= 0.25
    },
    pfimg() {
      if (this.multiples >= 2) {
        return
      }
      this.multiples += 0.25
    },
    //获取聊天框标题
    async getFromUserName() {
      const sessionId = this.itemId
      const sessionType = this.type
      if (this.type == 'chat') {
        //获取服务器会话信息
        let res = await this.$ImSdk.getSessionsInfo({
          id: this.itemId,
          userId: storage.get('userId'),
        })
        if (this.itemId !== sessionId || this.type !== sessionType) return
        
        if(res.groupMembers!=null){
          this.groupMembers = res.groupMembers.filter(u => u.id != storage.get('userId'))
        }
        console.log(this.groupMembers)
        if (res.noteName != null) {
          this.fromName = res.noteName
        } else {
          this.fromName = res.otherMember.nickname
        }
        //获取装修标识
        if (this.userId.indexOf('mb_') >= 0) {
          let resdata = await requestHttpGet(apiUrl + '/admin-api/supplier/user/user-member-info', {
            id: this.userId.split('mb_')[1],
          })
          if (resdata && resdata.data && resdata.data.identityType != null) {
            this.memberIdentityType = Number(resdata.data.identityType)
          } else {
            this.memberIdentityType = 0
          }
          this.fromNameZ = this.memberIdentityType === 1
        }
      }
      if (this.type == 'group') {
        //获取服务器会话信息
        let res = await this.$ImSdk.getSessionsInfo({
          id: this.itemId,
          userId: storage.get('userId'),
        })
        if (this.itemId !== sessionId || this.type !== sessionType) return
        console.log(res)
        this.groupMembers = (res.groupMembers || []).filter(u => u.id != storage.get('userId'))
        console.log(this.groupMembers)
        if (res.noteName != null) {
          this.fromName = res.noteName
        } else {
          this.fromName = res.name
        }
        console.log(this.fromName)
      }
    },
    async orderscrollEvent(e) {
      const { scrollTop } = e.target
      if (scrollTop === 0 && this.pageNo != 1) {
        await this.loadMore()
      }
    },
    async loadMore() {
      let that = this
      if (!this.hasMore) return
      let obj = {
        messageSessionId: this.itemId,
        type: this.type,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      let res = await this.$ImSdk.getMessagePage(obj)

      this.MessageList.unshift(...res)

      //设置会话清除@
      
      if (res.length <= 0) {
        this.hasMore = false
      } else {
        this.$nextTick(() => {
          //获取最后加载的最有一个div
          let toItem = document.getElementById('message' + res[res.length - 1]['id'])
          that.scrollToItem(toItem)
        })
      }
      this.pageNo++
    },
    scrollToItem(item) {
      if (item == null || !this.$refs.mianscroll) {
        return
      }
      let container = this.$refs.mianscroll
      let scrollTop = item.offsetTop + item.offsetHeight
      container.scrollTop = scrollTop
    },

    scrollToItemCenter(item) {
      if (item == null || !this.$refs.mianscroll) {
        return
      }
      let container = this.$refs.mianscroll
      // 按容器实际高度动态居中(原 -400 为硬编码，小窗口/DPI 缩放下定位偏移)
      let scrollTop = item.offsetTop - Math.max(0, (container.clientHeight - item.offsetHeight) / 2)
      container.scrollTop = Math.max(0, scrollTop)
    },
    buildDesignerOrderCustom(e, type) {
      if (!e || !e.items || !e.items.length) {
        return null
      }
      const firstItem = e.items[0]
      let obj = {
        id: e.id,
        no: e.no,
        name: firstItem.spuName,
        image: firstItem.picUrl,
        price: e.payPrice,
        status: e.status,
        refundStatus: e.refundStatus,
        type: type,
      }
      if (obj.status == 60 || obj.status == 70) {
        let changeType = 0
        let changeOrderNo = 0
        let changeOrderId = 0
        if (e.subOrder && e.subOrder.length) {
          e.subOrder.forEach(es => {
            if (es.id == e.newSubId) {
              changeType = es.type
              changeOrderNo = es.no
              changeOrderId = es.id
            }
          })
        }
        obj.changeType = changeType
        obj.changeOrderNo = changeOrderNo
        obj.changeOrderId = changeOrderId
        obj.type = 'designerChangeOrder'
      } else {
        obj.type = 'designerOrder'
      }
      return obj
    },
    //回调自定义消息
    async onBackZdy(e, type) {
      if (this.orderSending) {
        return
      }
      if (!this.userId || !this.type) {
        message.warning('请先选择会话')
        return
      }
      const obj = this.buildDesignerOrderCustom(e, type)
      if (!obj) {
        message.error('订单数据不完整，无法发送')
        return
      }
      if (!this.$ImSdk.isImConnected()) {
        message.error('IM 未连接，请检查网络后重试')
        return
      }
      this.orderSending = true
      const hide = message.loading('正在发送订单...', 0)
      try {
        const sent = await this.$ImSdk.sendCustomMessages(this.userId, this.type, obj, this, {}, 0)
        if (sent === false) {
          message.error('订单发送失败，请稍后重试')
          return
        }
        setTimeout(() => {
          let scrollEl = document.getElementById('message')
          if (scrollEl) {
            scrollEl.scrollTo({
              top: scrollEl.scrollHeight + 100,
              behavior: 'smooth',
            })
          }
        }, 50)
      } finally {
        hide()
        this.orderSending = false
      }
    },
    //回自定义足迹消息
    async onBackZj(e, type) {
      // 获取自定义消息类型 效果图  设计商品
      console.log(e)
      // 区分
      let extType = 0
      let ext = {}
      for (let index = 0; index < e.length; index++) {
        const item = e[index]
        let obj = {}
        if (item.type == 4) {
          //设计商品
          // obj.id = item.footprintDesignerProduct.id //商品id
          // obj.name = item.footprintDesignerProduct.name //商品名称
          // obj.image = item.footprintDesignerProduct.picUrl //商品图片
          // obj.price = item.footprintDesignerProduct.price

          if (item.footprintDesignerProduct) {
						obj.id = item.footprintDesignerProduct.id //商品id
						obj.name = item.footprintDesignerProduct.name //商品名称
						obj.image = item.footprintDesignerProduct.picUrl //商品图片
						obj.price = this.getqf(item.footprintDesignerProduct)
						obj.designerName = item.footprintDesignerProduct.designerName
						obj.designerLogo = item.footprintDesignerProduct.designerLogo
						obj.payNum = item.footprintDesignerProduct.salesCount
						obj.type = "designerProduct"
						obj.acceptanceTime = item.footprintDesignerProduct.acceptanceTime
					} 

          obj.type = type
        }
        if (item.type == 3) {
          //效果图
          obj.id = item.footprintRender.id //效果图d
          obj.name = item.footprintRender.name //效果图名称
          obj.image = item.footprintRender.coverPicUrls.split(',')[0] //效果图图片
          obj.price = 0

          if (item.footprintRender) {
						obj.id = item.footprintRender.id //效果图d
						obj.name = item.footprintRender.name //效果图名称
						obj.image = item.footprintRender.coverPicUrls.split(",")[0] //效果图图片
						obj.designerName = item.footprintRender.designerName
						obj.designerLogo = item.footprintRender.designerLogo
						obj.price = 0
						obj.type = "renderProduct"
						obj.browseNum = item.footprintRender.browseNum
						obj.card = this.getTags(item.footprintRender)
					}

          obj.type = type
        }
        console.log(obj)
        //发送自定义消息

        await this.$ImSdk.sendCustomMessages(this.userId, this.type, obj, this, ext, extType)
      }
      setTimeout(() => {
        let scrollEl = document.getElementById('message')
        scrollEl.scrollTo({
          top: scrollEl.scrollHeight + 100,
          behavior: 'smooth',
        })
      }, 50)
    },

    getTags(item) {
				console.log(item)

				let text = ""
				if (item.type == 2) {
					//家装 现代风 · 2室 · 120㎡
					//获取风格
					let stylePros = []
					this.stylesList.forEach(s => {
						if (item.styleIds) {
							if (item.styleIds.includes(s.id)) {
								stylePros.push(s.name)
							}
						}
					})
					
					//获取户型
					let housePros = ""
					this.housesList.forEach(h => {
						if (item.house) {
							if (item.house == parseInt(h.id)) {
								housePros = h.name
							}
						}
					})
					//获取面积
					let areaPros = " · " + item.area + '㎡'
					text = (stylePros.length > 0 ? stylePros[0] : '') + " · " + housePros + areaPros
				}
				if (item.type == 1) {
					//工装 大空间 · 120㎡
					//获取空间
					let spacePros = []
					this.spacesList.forEach(s => {
						if (item.spaceIds) {
							if (item.spaceIds.includes(s.id)) {
								spacePros.push(s.name)
							}
						}
					})
					//获取面积
					let areaPros = " · " + item.area + '㎡'
					text = (spacePros.length > 0 ? spacePros[0] : '') + areaPros
				}
				return text
			},
      getqf(item){
				return item.price
			},
    //设置内容
    backCy(e) {
      this.cyy = e
      this.textContent = e.text
    },
    updateInfos(e) {
      this.$emit('updateInfos', e)
    },
    gotoGroup(e) {
      console.log(e)
      this.$emit('gotoGroup', e)
    },
    closemin() {
      this.isShowInfos = false
      this.isShowExts = false
      this.isShowHistory = false
    },
    dragstart(e) {
      console.log(e)
      this.startclientX = e.clientX // 记录拖拽元素初始位置
      this.startclientY = e.clientY
    },
    // 拖拽完成事件
    dragend(e) {
      console.log(e)
      let x = e.clientX - this.startclientX // 计算偏移量
      let y = e.clientY - this.startclientY

      this.elLeft += x // 实现拖拽元素随偏移量移动
      this.elTop += y
      console.log(this.elLeft)
    },
    setValues(e) {
      this.textContent = e
    },
    getimage(item) {
      let res = require('@/assets/pngfile.png')
      switch (item.split('.')[1]) {
        case 'png':
          res = require('@/assets/pngfile.png')
          break
        case 'doc':
          res = require('@/assets/wfile.png')
          break
        case 'xlsx':
          res = require('@/assets/xfile.png')
          break
        case 'dwg':
          res = require('@/assets/cadfile.png')
          break
        case 'zip':
          res = require('@/assets/zfile.png')
          break
        case 'pptx':
          res = require('@/assets/pfile.png')
          break
        default:
          break
      }
      return res
    },
    openViode() {
      this.isShowRecordBox = true
    },
    backAudio() {
      this.isShowRecordBox = false
    },
    setForwardItem(item) {
      this.MessageList.forEach((e)=>{
        if(e.id == item.id){
          e.isSelect = item.isSelect
        }
      })
      this.downloadSelectVersion++
      this.$forceUpdate()
    },

    //发送文本消息
    async sendTextMessage() {
      if (this.textSending) {
        return
      }
      const text = this.textContent == null ? '' : String(this.textContent).trim()
      if (!text) {
        return
      }
      if (!this.userId || !this.type) {
        message.warning('请先选择会话')
        return
      }
      if (!this.$ImSdk.isImConnected()) {
        message.error('IM 未连接，请检查网络后重试')
        return
      }
      let extType = 0
      let ext = {}
      if (this.showQuote) {
        extType = 1
        ext = this.pressItem
      }
      //设置@消息
			if(this.type == 'group'){
					if (text.indexOf('@')>=0) {
						if(text.indexOf('@所有人')>=0){
							this.groupMembers.forEach(e=>{
								if(e.id!= storage.get('userId')){
									this.be_ids.push(e.id)
								}
							})
						}
						this.groupMembers.forEach(e=>{
							const token = '@' + e.nickname
							let fromIndex = 0
							while (fromIndex < text.length) {
								const idx = text.indexOf(token, fromIndex)
								if (idx < 0) break
								const nextChar = text.charAt(idx + token.length)
								if (!nextChar || nextChar === ' ' || nextChar === '\n') {
									this.be_ids.push(e.id)
								}
								fromIndex = idx + token.length
							}
						})
					}
					if(this.be_ids.length>0){
						ext.be_ids = [...new Set(this.be_ids)].join(",")
					}
					this.be_ids = []
				}
      this.textSending = true
      try {
        const sent = await this.$ImSdk.sendTextMessage(this.userId, this.type, text, this, ext, extType)
        if (sent === false) {
          message.error('消息发送失败，请稍后重试')
          return
        }
        this.textContent = ''
        this.showQuote = false
        setTimeout(() => {
          let scrollEl = document.getElementById('message')
          if (scrollEl) {
            scrollEl.scrollTo({
              top: scrollEl.scrollHeight + 100,
              behavior: 'smooth',
            })
          }
        }, 50)
      } finally {
        setTimeout(() => {
          this.textSending = false
        }, 400)
      }
    },
    async sendFilesMessages(e) {
      console.log(e)
      let extType = 0
      let ext = {}
      console.log(this.$refs.uploadFiles.files[0])
      await this.$ImSdk.sendFileMessage(this.userId, this.type, this.$refs.uploadFiles.files[0], ext, extType)
      setTimeout(() => {
        let scrollEl = document.getElementById('message')
        scrollEl.scrollTo({
          top: scrollEl.scrollHeight + 100,
          behavior: 'smooth',
        })
      }, 50)
      this.$refs.uploadFiles.value = null
    },
    async sendImagesMessage(type) {
      this.islond = true
      let extType = 0
      let ext = {}
   
      if (type == 'common') {
        console.log(this.$refs.uploadImgs.files)
        //先快照文件列表：清空 input.value 会清空整个 FileList，
        //放循环内会导致多选 N 张只发出第一张
        const fileArr = Array.from(this.$refs.uploadImgs.files || [])
        for (let index = 0; index < fileArr.length; index++) {
          await this.$ImSdk.sendImagesMessage(this.userId, this.type, fileArr[index], ext, extType)
        }
        this.$refs.uploadImgs.value = null
      } else if (type == 'other') {
        await this.$ImSdk.sendImagesMessage(this.userId, this.type, this.fileObj, ext, extType)
        this.fileObj = null
      }
      this.islond = false
    },
    async sendVideoMessages() {
      let extType = 0
      let ext = {}
      await this.$ImSdk.sendVideoMessage(this.userId, this.type, this.$refs.uploadVideo.files[0], ext, extType)
      setTimeout(() => {
        let scrollEl = document.getElementById('message')
        scrollEl.scrollTo({
          top: scrollEl.scrollHeight + 100,
          behavior: 'smooth',
        })
      }, 50)
      this.isShowRecordBox = false
    },
    async sendAudioMessages(audioData) {
      let extType = 0
      let ext = {}
      await this.$ImSdk.sendAudioMessage(this.userId, this.type, audioData, ext, extType)
      setTimeout(() => {
        let scrollEl = document.getElementById('message')
        scrollEl.scrollTo({
          top: scrollEl.scrollHeight + 100,
          behavior: 'smooth',
        })
      }, 50)
      this.isShowRecordBox = false
    },
    onPasteImage(event) {
      let that = this
      console.log('>>>>>>监听粘贴事件', event)
      const data = event.clipboardData || window.clipboardData
      //获取图片内容
      const imgContent = data.items[0]
      console.log(imgContent)
      console.log(imgContent.getAsFile())
      const reader = new FileReader()
      if (imgContent.kind === 'file' && imgContent.type.startsWith('image/')) {
        //图片
        that.fileObj = imgContent.getAsFile()
        reader.readAsDataURL(imgContent.getAsFile())
        reader.onload = event => {
          //获取base64流
          that.fileBase64 = event.target.result
          console.log('发送图片', that.fileBase64)
          that.sendImagePlant()
        }
      }
      if (imgContent.kind === 'file' && !imgContent.type.startsWith('image/')) {
        //文件
        console.log('发送文件')
        that.fileObj = imgContent.getAsFile()
        that.sendFilePlant()
      }
    },
    sendImagePlant() {
      this.showImagePlant = true
    },
    sendFilePlant() {
      this.showFilePlant = true
    },
    openReadDetail(item) {
      this.readDetailItem = item
      this.readDetailTab = 0
      this.readDetailVisible = true
    },
    sendImageSum() {
      this.sendImagesMessage('other')
      this.showImagePlant = false
      this.showFilePlant = false
    },
    sendDemandOrder(){
      this.ProructVisible = true
    },
    openOrders() {
      this.ProructVisible = true
      this.demandId = 0
    },
    openDir(id) {
      if (this.$ipc) {
        this.$ipc.invoke(ipcApiRoute.openFile, { id: id }).then(result => {
          console.log(result)
        })
      }
    },
    cheoosImage() {
      this.$refs.uploadImgs.click()
    },
    cheoosfile() {
      this.$refs.uploadFiles.click()
    },
    SendViode() {
      this.$refs.uploadVideo.click()
    },
    cheoosHistory() {
      this.isShowInfos = false
      this.isShowExts = false
      this.isShowHistory = !this.isShowHistory
    },
    cheoosInfos() {
      if (this.type == 'group') {
        this.isShowHistory = false
        this.isShowExts = false
        this.isShowInfos = !this.isShowInfos
      }
    },
    cheoosExts() {
      if (this.type != 'group') {
        this.isShowInfos = false
        this.isShowHistory = false
        this.isShowExts = !this.isShowExts
      } else if (this.type == 'group') {
        this.isShowInfos = false
        this.isShowHistory = false
        this.isShowExts = !this.isShowExts
      }
    },
    addOneEmoji(emoji) {
      this.textContent = this.textContent + emoji
      this.emoVisible = !this.emoVisible
      // this.sendTextMessage()
    },
    openEmo() {
      this.dialogStyle.top = document.getElementById('message').offsetHeight - 62 + 'px'
      this.emoVisible = !this.emoVisible
    },
    //初始化历史消息
    // IM 断线重连成功：重新拉取当前会话最新一页并滚动到底部，补齐断线期间漏收的消息
    async handleReconnected() {
      if (!this.itemId) {
        return
      }
      await this.getHostList()
    },
    async getHostList() {
      console.log('获取会话消息', this.itemId)
      //类型错误返回
      if (!this.type) {
        return
      }
      this.MessageList = []
      //会话id错误返回
      if (!this.itemId) {
        console.log(this.itemId)
        console.log('无会话消息')
        return
      }
      //获取头部信息
      await this.getFromUserName()
      //获取消息
      console.log(this.type)
      this.hasMore = true
      this.pageNo = 1
      await this.loadMore()
    },
    down(e) {
      this.flag = true
      this.oldY = e.pageY //记录鼠标按下位置
      this.targetDiv = document.getElementById('intextTuo')
      this.targetDivHeight = this.targetDiv.offsetHeight
      this.targetTopDiv = document.getElementById('message')
      this.targetTopDivHeight = this.targetTopDiv.offsetHeight
      this.startTd(e)
    },
    startTd(ev) {
      let that = this
      let height = 0
      let moveY = 0
      this.flag = true
      window.addEventListener('mousemove', e => {
        if (that.flag) {
          moveY = e.pageY //检测鼠标移动位置
          height = this.oldY - moveY
          if (height > 0) {
            if (this.targetDivHeight + Math.abs(height) <= 400) {
              document.getElementById('intextTuo').style.height = this.targetDivHeight + Math.abs(height) + 'px'
              document.getElementById('message').style.height = this.targetTopDivHeight - Math.abs(height) + 'px'
            }
          } else {
            if (this.targetDivHeight - Math.abs(height) >= 122) {
              document.getElementById('intextTuo').style.height = this.targetDivHeight - Math.abs(height) + 'px'
              document.getElementById('message').style.height = this.targetTopDivHeight + Math.abs(height) + 'px'
            }
          }
          that.$nextTick(() => {
            //获取最后加载的最有一个div
            let toItem = document.getElementById('message' + this.MessageList[this.MessageList.length - 1]['id'])
            that.scrollToItem(toItem)
          })
        }
      })

      window.addEventListener('mouseup', e => {
        console.log('鼠标抬起')
        that.flag = false
      })
    },
    up(e) {
      this.flag = false
    },
    min(type) {
      this.$ipc.invoke(ipcApiRoute.action, type).then(result => {
        console.log(result)
      })
    },
    minimg() {
      this.imgVisible = false
    },
    getMessageFromMemberName() {
      let txtName = ''
      this.pressItem.members.forEach(e => {
        if (this.pressItem.messageFrom == e.id) {
          txtName = e.nickname
        }
      })
      return txtName
    },
    openMenu(e) {
      let event = e.event
      let item = e.item
      console.log("右键事件打开层")
      this.pressItemTo = item
      event.preventDefault()
      var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      var wheight = document.getElementById('intextTuo') ? document.getElementById('intextTuo').offsetHeight : 122
      // 显示自定义菜单
      this.menuVisible = true
      
      // 设置菜单的位置
      if (width - 250 > event.clientX) {
        this.menuStyle.left = `${event.clientX}px`
      } else {
        this.menuStyle.left = `${width - 250}px`
      }
      if (height - wheight - 190 > event.clientY) {
        this.menuStyle.top = `${event.clientY}px`
      } else {
        this.menuStyle.top = `${height - wheight - 190}px`
      }
      this.$forceUpdate()
      console.log(this.menuStyle)
    },
    async openDemand(id){
        console.log(id)
        let res = await requestHttpGet(apiUrl + '/app-api/member/demand/get', { id: id })
        this.demandDetail = res.data
        
        if(this.demandDetail.demandPros){
          this.demandDetail.demandPros = JSON.parse(this.demandDetail.demandPros)
          this.setArrList(this.demandDetail.demandPros[0])
        }
        this.showDemandPlant = true
        this.demandId = id
    },
    menuItemClicked(action) {
      // 处理菜单项的点击事件
      console.log(action)
      console.log(this.pressItemTo)
      this.isMore = false
      this.showForwrad = false
      this.showQuote = false
      // 可以根据action执行不同的操作
      if (action == 'copy') {
        let oInput = document.createElement('input')
        // 将想要复制的值
        oInput.value = this.pressItemTo.messageMsg
        // 页面底部追加输入框
        document.body.appendChild(oInput)
        // 选中输入框
        oInput.select()
        // 执行浏览器复制命令
        document.execCommand('Copy')
        // 弹出复制成功信息
        oInput.remove()
        message.info('复制成功!')
      }
      if (action == 'forward') {
        this.showForwrad = true
        this.pressItem = this.pressItemTo
        this.forwardType = 1 //单条转发
      }
      if (action == 'quote') {
        this.showQuote = true
        this.quoteStyle.bottom = '122px'
        this.pressItem = this.pressItemTo
      }
      if (action == 'select') {
        this.isMore = true
        this.showForwrad = true
        this.forwardType = 2 //多条转发
      }
      if (action == 'back') {
        this.pressItem = this.pressItemTo
        this.backMessage(this.pressItem)
      }
      if (action == 'addimg') {
        const url = this.getReferencePicUrl(this.pressItemTo)
        if (!url) {
          message.warning('当前消息无法添加到参考图库')
        } else {
          this.addToRefPicUrl = url
          this.addToRefVisible = true
        }
      }
      // 最后隐藏菜单
      this.menuVisible = false
    },
    canAddToReference(item) {
      if (!item) return false
      if (item.messageType === 'img') return !!item.messageUrl
      if (item.messageType === 'custom' && item.messageCustomExt && item.messageCustomExt.type === 'renderProduct') {
        return !!item.messageCustomExt.image
      }
      return false
    },
    getReferencePicUrl(item) {
      if (!item) return ''
      if (item.messageType === 'img') return item.messageUrl || ''
      if (item.messageType === 'custom' && item.messageCustomExt && item.messageCustomExt.type === 'renderProduct') {
        return item.messageCustomExt.image || ''
      }
      return ''
    },
    openReferenceGallery() {
      this.refGalleryVisible = true
    },
    async onReferenceGalleryOk({ pics }) {
      if (!pics || !pics.length) return
      this.islond = true
      try {
        const extType = 0
        const ext = {}
        for (let i = 0; i < pics.length; i++) {
          const url = pics[i]
          await this.$ImSdk.sendForwardImagesMessage(
            this.userId,
            this.type,
            {
              messageUrl: url,
              messageFileLength: 0,
              messageFileName: 'reference_' + Date.now() + '_' + i + '.jpg',
            },
            ext,
            extType
          )
        }
        setTimeout(() => {
          let scrollEl = document.getElementById('message')
          if (scrollEl) {
            scrollEl.scrollTo({
              top: scrollEl.scrollHeight + 100,
              behavior: 'smooth',
            })
          }
        }, 50)
      } finally {
        this.islond = false
      }
    },
    openForwardDailog(v) {
      console.log("打开转发扩展弹窗")
      this.forwardList = []
      if (this.forwardType == 1) {
        //单条
        this.forwardList.push(this.pressItem)
      }
      if (this.forwardType == 2) {
        //多条
        this.MessageList.forEach(e => {
          if (e.isSelect) {
            this.forwardList.push(e)
          }
        })
      }
      if (this.forwardList.length <= 0) {
        return
      }
      if (this.forwardList.length == 1) {
        this.forwardMessageTitle = this.forwardList[0].messageMsg
      }
      if (this.forwardList.length > 1) {
        if (this.type == 'group') {
          this.forwardMessageTitle = this.fromName + '群聊的聊天记录'
        }
        if (this.type == 'chat') {
          this.forwardMessageTitle = storage.get('UserName') + '与' + this.fromName + '的聊天记录'
        }
      }
      this.forwardSendType = v
      if (this.forwardSendType == 0) {
        this.forwardMessageTitle = '[逐条转发]' + this.forwardMessageTitle
      }
      if (this.forwardSendType == 1) {
        this.forwardMessageTitle = '[合并转发]' + this.forwardMessageTitle
      }
      console.log("打开转发扩展弹窗",this.forwardList)
      this.forwardDailog = true
    },
    
    closeForwardDailog() {
      this.forwardDailog = false
    },
    //批量下载：多选中的文件/图片/视频消息逐个保存到本地
    async batchDownload() {
      // 与 hasDownloadableSelected 同一谓词，保证“按钮可用 ⇔ 确实有可下载项”
      const targets = this.MessageList.filter(e => {
        if (!e.isSelect) {
          return false
        }
        if (e.status == 2) { // 已撤回消息不可下载
          return false
        }
        const url = e.messageUrl || e.videoUrl
        return url && DOWNLOADABLE_MESSAGE_TYPES.indexOf(e.messageType) >= 0
      })
      if (targets.length <= 0) {
        message.warning('所选消息中没有可下载的文件')
        return
      }
      for (const item of targets) {
        const url = item.messageUrl || item.videoUrl
        try {
          const res = await fetch(url)
          if (!res.ok) {
            throw new Error('HTTP ' + res.status)
          }
          const blob = await res.blob()
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          let name = item.messageFileName
          if (!name) {
            name = url.split('/').pop().split('?')[0] || ('文件' + Date.now())
          }
          if (item.messageType == 'img' && name.indexOf('.') < 0) {
            name = name + '.png'
          }
          if (item.messageType == 'video' && name.indexOf('.') < 0) {
            name = name + '.mp4'
          }
          link.download = name
          document.body.appendChild(link)
          link.click()
          link.remove()
          //连续下载间隔，降低浏览器批量拦截概率
          await new Promise(r => setTimeout(r, 300))
        } catch (err) {
          console.error('批量下载单条失败', err)
          message.error('下载失败：' + (item.messageFileName || url))
        }
      }
    },
    closeForward() {
      this.showForwrad = false
      this.isMore = false
      this.MessageList.forEach(e => {
        e.isSelect = false
      })
      this.downloadSelectVersion++
      this.$forceUpdate()
    },
    closequote() {
      this.showQuote = false
    },
    getIsGoBack() {
      console.log("条件渲染")
      console.log(this.pressItemTo)
      let sTime = this.pressItemTo.createTime
      let eTime = new Date().getTime()
      console.log(this.pressItemTo)
      console.log(eTime - sTime < 120000 && this.pressItemTo.belong)
      if (eTime - sTime < 120000 && this.pressItemTo.belong) {
        return true
      }
      return false
    },
    getExtType(item) {
      return JSON.parse(item.messageExt).messageType
    },
    getExtName(item) {
      let nameText = ''
      let ms = JSON.parse(item.messageExt)
      ms.members.forEach(e => {
        if (ms.messageFrom == e.id) {
          nameText = e.nickname
        }
      })
      return nameText
    },

    getExtCustom(item) {
      let ms = JSON.parse(item.messageExt)
      return this.getCustomTitle(ms)
    },
    getInfoCustom(item) {
      return this.getCustomTitle(item)
    },
    getCustomTitle(e) {
      if (e.messageCustomExt.type == 'designerOrder') {
        if (e.messageCustomExt.status == 100) {
          return '订单已关闭'
        }
        if (e.messageCustomExt.status == 0) {
          return '请您确认支付'
        }
        if (e.messageCustomExt.status == 10) {
          return '已支付'
        }
        if (e.messageCustomExt.status == 20) {
          return '请您确认需求'
        }
        if (e.messageCustomExt.status == 30) {
          return '制图中'
        }
        if (e.messageCustomExt.status == 40) {
          return '请您确认图纸'
        }
        if (e.messageCustomExt.status == 50) {
          return '已完成'
        }
      }
      if (e.messageCustomExt.type == 'selectOrder') {
        return '商品价格改好了，可直接付款哦'
      }
      if (e.messageCustomExt.type == 'demandOrder') {
        return '我发送了一个设计需求，请尽快查看并回复哦~'
      }
      if (e.messageCustomExt.type == 'designerFixOrder') {
        return '请您支付补差金额'
      }
      if (e.messageCustomExt.type == 'renderProduct') {
        return '效果图'
      }

      if (e.messageCustomExt.type == 'submitChangeSuccess') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'payFixSuccess') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'demandSuccess') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'payFixSuccess') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'paySuccess') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'refundOrder') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'refundChangeOrder') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'refundOrderSuccess') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'refundChangeOrderSuccess') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'subimtSuccess') {
        return e.messageCustomExt.title
      }
      if (e.messageCustomExt.type == 'designerChangeOrder') {
        if (e.messageCustomExt.status == 60) {
          return '请您确认修改需求'
        }
        if (e.messageCustomExt.status == 70) {
          return '改图制图中'
        }
        if (e.messageCustomExt.status == 50) {
          return '已完成'
        }
        if (e.messageCustomExt.status == 0) {
          return '请您确认修改需求'
        }
      }
    },
    getExtMsg(item) {
      let msg = JSON.parse(item.messageExt).messageMsg
      if (msg.indexOf('[') >= 0) {
        let msgs = msg
        //分析出所有表情
        for (const key in emMap) {
          if (msg.indexOf(key) >= 0) {
            for (var i = 0; i < 20; i++) {
              msgs = msgs.replace(key, '<image style="width:18px;height:18px;" src="' + ('https://cdn.binliyoujia.com/static/im/faces/' + emMap[key]) + '"/>')
            }
          }
        }
        return msgs
      } else {
        return msg
      }
    },
    getMemberName(item) {
      let nameText = ''
      item.members.forEach(e => {
        if (item.messageFrom == e.id) {
          nameText = e.nickname
        }
      })
      return nameText
    },
    getExtImg(item) {
      let ms = JSON.parse(item.messageExt)
      return ms.messageUrl
    },
    getExtFileName(item) {
      let ms = JSON.parse(item.messageExt)
      return ms.messageFileName
    },

    getExtAudioLength(item) {
      let ms = JSON.parse(item.messageExt)
      return ms.messageAudioLength
    },
    getExtVideoUrl(item) {
      let ms = JSON.parse(item.messageExt)
      return ms.videoUrl
    },
    searchHanlde(v) {
      if (this.forwardSearchValue == '') {
        this.sessionList.forEach(e => {
          e.isShow = true
        })
      }
      this.sessionList.forEach(e => {
        if (e.type == 'chat') {
          let str = e.otherMember.nickname
          if (str.indexOf(this.forwardSearchValue) >= 0) {
            e.isShow = true
          } else {
            e.isShow = false
          }
        }
        if (e.type == 'group') {
          let str = e.noteName ? e.noteName : e.name
          if (str.indexOf(this.forwardSearchValue) >= 0) {
            e.isShow = true
          } else {
            e.isShow = false
          }
        }
      })
    },
    getExtFileIcon(item) {
      let ms = JSON.parse(item.messageExt)
      let imageUrl = ''
      console.log(ms.messageFileName)
      let fileExtension = ms.messageFileName.substring(ms.messageFileName.lastIndexOf('.') + 1)
      if (fileExtension == 'zip' || fileExtension == 'ZIP') {
        imageUrl = 'zip'
      }
      if (fileExtension == 'doc' || fileExtension == 'docx' || fileExtension == 'DOC' || fileExtension == 'DOCX') {
        imageUrl = 'word'
      }
      if (fileExtension == 'xls' || fileExtension == 'xlsx' || fileExtension == 'XLS' || fileExtension == 'XLSX') {
        imageUrl = 'xls'
      }
      if (fileExtension == 'txt' || fileExtension == 'TXT') {
        imageUrl = 'txt'
      }
      if (fileExtension == 'pdf' || fileExtension == 'PDF') {
        imageUrl = 'pdf'
      }
      if (fileExtension == 'ppt' || fileExtension == 'pptx' || fileExtension == 'PPT' || fileExtension == 'PPTX') {
        imageUrl = 'ppt'
      }
      if (fileExtension == 'dwg' || fileExtension == 'dxf' || fileExtension == 'DWG' || fileExtension == 'DXF') {
        imageUrl = 'cad'
      }
      if (fileExtension == 'jpg') {
        imageUrl = 'jpg'
      }
      return 'https://cdn.binliyoujia.com/static/message/message-img/' + imageUrl + '.png'
    },
    setMessageItem(item) {
      if (item.messageType == 'audio') {
        return
      }
      item.isSelect = !item.isSelect
      this.downloadSelectVersion++
      this.$forceUpdate()
    },
    goToQuoteMessage(item){
      let that = this
      that.$nextTick(() => {
          //获取被引用消息的div
          let toItem = document.getElementById('message' + item.messageExt.id)
          if (toItem == null) {
            // 引用的消息不在当前已加载的分页里(更早的历史)：滚到顶部触发加载上一页，
            // 加载后再点引用继续逼近；原实现 null.offsetTop 直接报错，点击表现为无反应
            if (that.$refs.mianscroll) {
              that.$refs.mianscroll.scrollTop = 0
            }
            return
          }
          that.scrollToItemCenter(toItem)
        })
    },
    //消息列表打开转发消息详情
    openForwardMessageListDailogByList(item) {
      this.dataMessageList =item.messageExt
      this.forwardMessageTitle = item.messageMsg
      let timeStart = []
      this.dataMessageList.forEach(e => {
        let timeText = dateFormater('YYYY-MM-DD', e.createTime)
        if (!timeStart.includes(timeText)) {
          timeStart.push(timeText)
        }
        e.textTime = dateFormater('MM/DD HH:mm:ss', e.createTime)
      })
      if (timeStart.length > 1) {
        timeStart.sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
        this.consoleTime = timeStart[0] + '~' + timeStart[timeStart.length - 1]
      } else {
        this.consoleTime = timeStart[0]
      }
      this.forwardMessageListDailog = true
    },

    //转发窗体打开转发消息详情
    openForwardMessageListDailog() {
      this.dataMessageList = this.forwardList
      let timeStart = []
      this.dataMessageList.forEach(e => {
        let timeText = dateFormater('YYYY-MM-DD', e.createTime)
        if (!timeStart.includes(timeText)) {
          timeStart.push(timeText)
        }
        e.textTime = dateFormater('MM/DD HH:mm:ss', e.createTime)
      })
      if (timeStart.length > 1) {
        timeStart.sort((a, b) => new Date(a).getTime() - new Date(b).getTime())
        this.consoleTime = timeStart[0] + '~' + timeStart[timeStart.length - 1]
      } else {
        this.consoleTime = timeStart[0]
      }
      this.forwardMessageListDailog = true
    },
    closeForwardMessageListDailog() {
      this.forwardMessageListDailog = false
    },

    //获取扩展消息
    getExtMessages(item) {
      let forwardArr = []
      forwardArr = JSON.parse(item.messageExt).exts
      console.log(forwardArr)
      return forwardArr
    },
    //撤回消息动作
    async backMessage() {
      let messageId = this.pressItem.id
      let res = await requestHttpGet(apiUrl + '/app-api/netty/im-message/back-message', { id: messageId })
      if (res.data) {
        message.info('撤回成功!')
      }
    },
    setArrList(item){
        this.demandDetail.houseIndexId = item.id
        this.spaceDetailArrList = []
        item.darr.forEach(e=>{
					this.spaceDetailArrList.push(e)
				})
        // this.spaceDetailArrList.forEach(e=>{
				// 	e.child = []
				// 	e.sarr.forEach(a=>{
				// 		a.smarr.forEach(m=>{
				// 			e.child.push(m)
				// 		})
				// 	})
				// })
        console.log(this.spaceDetailArrList)
        this.$forceUpdate()
    },
    getHoseName(v){
      let text = ""
      this.housesList.forEach(e=>{
        if(e.value == v.houseId){
          text = e.label
        }
      })
      return text
    },
    getStyleName(v){
      let text = []
      this.stylesList.forEach(e=>{
        if(v.styleIds!=null){
          if(v.styleIds.includes(e.id)){
            text.push(e.name)
          }
        }
      })
      return text.join(",")
    },
    getSpaceName(v){
      let text = []
      this.spacesList.forEach(e=>{
        if(v.spaceIds!=null){
          if(v.spaceIds.includes(e.id)){
            text.push(e.name)
          }
        }
      })
      return text.join(",")
    },
    //撤回消息事件
    updateBackMessage(e) {
      console.log('收到撤回消息通知', e)
      if (this.itemId == e.messageSessionId) {
        //当前会话 设置消息撤回
        this.MessageList.forEach(m => {
          if (m.id == e.id) {
            m.status = 2
          }
        })
      }
    },
    changeInputText(e) {

				if(e.target.value == '@' && this.type == 'group'){
					console.log("调用@群组")
					this.textContentIndex = e.target.value.lastIndexOf("@")
          this.dialogBeStyle.top = document.getElementById('message').offsetHeight - 62 + 'px'
					this.popupShowBe = true
				}
				// this.setMessageHeight()
		},
  },
}
</script>
<style lang="less" scoped>
page {
  font-family: 'PingFang SC';
}
.red {
  width: 10px;
  height: 10px;
  background-image: url('~@/assets/red1.png');
  background-size: 100%;
  margin-left: 10px;
  align-self: center;
  margin-top: 20px;
}
.red2 {
  width: 10px;
  height: 10px;
  background-image: url('~@/assets/red2.png');
  background-size: 100%;
  margin-left: 10px;
  align-self: center;
  margin-top: 20px;
}

.message-time {
  text-align: left;
  margin-left: 42px;
  margin-top: 6px;
  font-family: PingFangSC-Regular;
  font-size: 10px;
  font-weight: normal;
  line-height: 12px;
  letter-spacing: 0px;
  color: #999999;
}

.message-time-my {
  text-align: right;
  margin-right: 65px;
  margin-top: 6px;
  font-family: PingFangSC-Regular;
  font-size: 10px;
  font-weight: normal;
  line-height: 12px;
  letter-spacing: 0px;
  color: #999999;
}

.message-box {
  margin-top: 22px;
  margin-left: 22px;
  user-select: text;
  margin-bottom: 20px;
}

#app-base-file {
  width: 100%;
  min-width: 0;
  background-color: #fff;
  height: 100%;
  position: relative;
}

.inputbox {
  min-height: calc(100% - 50px);
  position: relative;
}

.chat_content_editable {
  font-family: 'PingFang SC';
  width: 100%;
  box-sizing: border-box;
  height: 100%;
  border: none;
  background: none;
  letter-spacing: 0.5px;
  resize: none;
  /* 右侧预留发送按钮宽(56) + 边距，避免侧栏打开输入区变窄时文字与按钮重叠 */
  padding: 0 86px 10px 22px;
  font-size: 12px;
  line-height: 14px;
}

textarea {
  outline: none;
}

.intext-action {
  height: 37px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  margin-left: 23px;
  margin-right: 23px;
  min-width: 0;
  overflow: hidden;
  gap: 8px;
}

.left-action {
  height: 37px;
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
}

.right-action {
  flex: 0 0 auto;
  min-width: 0;
}

.right-action-inner {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  cursor: pointer;
  white-space: nowrap;
}

.bq {
  width: 17px;
  height: 17px;
  background-image: url('~@/assets/bq.png');
  background-size: 100%;
  margin-top: 10px;
  margin-right: 18px;
  cursor: pointer;
}

.tp {
  width: 17px;
  height: 17px;
  background-image: url('~@/assets/tp.png');
  background-size: 100%;
  margin-top: 10px;
  margin-right: 18px;
  cursor: pointer;
}

.wj {
  width: 17px;
  height: 17px;
  background-image: url('~@/assets/wj.png');
  background-size: 100%;
  margin-top: 10px;
  margin-right: 18px;
  cursor: pointer;
}

.ls {
  width: 17px;
  height: 17px;
  background-image: url('~@/assets/ls.png');
  background-size: 100%;
  margin-top: 10px;
  margin-right: 18px;
  cursor: pointer;
}

.yy {
  width: 17px;
  height: 17px;
  background-image: url('~@/assets/yy.png');
  background-size: 100%;
  margin-top: 10px;
  margin-right: 18px;
  cursor: pointer;
}

.sp {
  width: 17px;
  height: 17px;
  background-image: url('~@/assets/shipin.png');
  background-size: 100%;
  margin-top: 10px;
  margin-right: 18px;
  cursor: pointer;
}

.yq {
  width: 14px;
  height: 14px;
  background-image: url('~@/assets/yqxd.png');
  background-size: 100%;
  margin-top: 0;
  margin-right: 8px;
  flex-shrink: 0;
  cursor: pointer;
}

.ck {
  width: 14px;
  height: 14px;
  background-image: url('https://cdn.binliyoujia.com/static/message/addimg-pc.png');
  background-size: 100%;
  margin-top: 0;
  margin-right: 6px;
  flex-shrink: 0;
  cursor: pointer;
}

.order {
  width: 17px;
  height: 17px;
  background-image: url('~@/assets/order.png');
  background-size: 100%;
  margin-top: 0;
  flex-shrink: 0;
  cursor: pointer;
}

.message {
  width: 100%;
  height: calc(100% - 125px);
  background-color: #fff;
  overflow-y: auto;
}
.message::-webkit-scrollbar {
  background-color: transparent;
  /* 原 3px 太细难点击/拖动，滑块过浅看不见：加宽并加深滑块颜色 */
  width: 8px;
}
.message::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 4px;
}
.message::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0, 0, 0, 0.5);
}
.message::-webkit-scrollbar-track {
  background-color: transparent;
}
.message::-webkit-scrollbar-thumb {
  border-radius: 20px;
  box-shadow: inset 0 0 1px rgba(0, 0, 0, 0.1);
  background: #eee;
}
.intext-tuo {
  height: 122px;
  opacity: 1;
  background: #ffffff;
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  cursor: s-resize;
  position: absolute;
  bottom: 0px;
  width: 100%;
}

.intext-tuo:hover {
  cursor: s-resize;
}

.intext {
  height: calc(100% - 2px);
  margin-top: 1px;
}

.intext:hover {
  cursor: default;
}

.header {
  width: 100%;
  height: 73px;
  // background-color: blanchedalmond;
  -webkit-app-region: drag;
  -webkit-user-select: none;
  box-shadow: 0px 2px 12px 0px rgba(0, 0, 0, 0.08), inset 0px -1px 0px 0px #eeeeee;
}

.header-action {
  height: 21px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
}

.min {
  width: 11px;
  height: 11px;
  background-image: url('~@/assets/main-min.png');
  background-size: 100%;
  background-position: center;
  margin-top: 5px;
  -webkit-app-region: no-drag;
  margin-left: 5px;
}

.max {
  width: 11px;
  height: 11px;
  background-image: url('~@/assets/main-max.png');
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: center;
  margin-top: 5px;
  margin-left: 5px;
  -webkit-app-region: no-drag;
}

.close {
  width: 11px;
  height: 11px;
  background-image: url('~@/assets/main-close.png');
  background-size: 100%;
  margin-top: 5px;
  margin-left: 5px;
  -webkit-app-region: no-drag;
}
.close-order {
  width: 18px;
  height: 18px;
  background-image: url('~@/assets/main-close.png');
  background-size: 100%;
  margin-top: 16px;
  margin-left: 5px;
  -webkit-app-region: no-drag;
}
.close-right {
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/main-close.png');
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  -webkit-app-region: no-drag;
}
.close-right:hover {
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/main-close-w.png');
  background-size: 60%;
  background-repeat: no-repeat;
  background-position: 50% 50%;
  -webkit-app-region: no-drag;
}
.min-box {
  width: 21px;
  cursor: pointer;
}
.min-box:hover {
  width: 21px;
  background-color: #eeeeee;
}
.min-box-right {
  width: 21px;
  margin-right: 10px;
  cursor: pointer;
}
.min-box-right:hover {
  width: 21px;
  margin-right: 10px;
  background-color: #ed2616;
}
.more {
  width: 17px;
  height: 3px;
  background-image: url('~@/assets/main-more.png');
  background-size: 100%;
  margin-top: 10px;
  -webkit-app-region: no-drag;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer;
}

.title {
  height: 23px;

  display: flex;
  justify-content: space-between;
  margin-right: 16px;
  margin-left: 22px;
  margin-top: 7px;
}

.voice-call-entry {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  margin-top: 9px;
  margin-right: 18px;
  padding: 0;
  border: 0;
  color: #222;
  background: transparent;
  cursor: pointer;
}

.voice-call-entry:hover {
  color: #fe5d42;
}

.voice-call-entry:focus {
  outline: none;
}

.voice-call-icon {
  width: 18px;
  height: 18px;
  fill: none;
  stroke: currentColor;
  stroke-width: 2;
  stroke-linecap: round;
  stroke-linejoin: round;
}

.private-call-panel {
  min-height: 160px;
  color: #222;
}

.private-call-section-title {
  margin-bottom: 10px;
  color: #555;
  font-size: 14px;
}

.private-call-section-title span {
  margin-left: 2px;
  color: #ed2616;
}

.private-call-targets {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
  margin-bottom: 14px;
}

.private-call-target {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 0;
  height: 70px;
  padding: 10px 42px 10px 12px;
  overflow: hidden;
  border: 1px solid #ddd;
  border-radius: 6px;
  color: #222;
  background: #fff;
  text-align: left;
  cursor: pointer;
}

.private-call-target.active {
  border-color: #ed2616;
  background: #fff9f8;
}

.private-call-target-avatar {
  flex: 0 0 46px;
  width: 46px;
  height: 46px;
  margin-right: 11px;
  border-radius: 50%;
  object-fit: cover;
}

.private-call-target-fallback {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #f0a45d;
  font-size: 18px;
}

.private-call-target-name {
  overflow: hidden;
  font-size: 15px;
  font-weight: 600;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.private-call-target-check {
  position: absolute;
  top: 23px;
  right: 14px;
  display: none;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  color: #fff;
  background: #ed2616;
}

.private-call-target.active .private-call-target-check {
  display: flex;
}

.private-call-protection {
  display: flex;
  justify-content: space-between;
  padding: 12px 0;
  border-top: 1px solid #eee;
  border-bottom: 1px solid #eee;
  color: #666;
}

.private-call-protection strong {
  color: #16a45b;
  font-weight: 500;
}

.private-call-empty {
  padding: 54px 0;
  color: #999;
  text-align: center;
}

.private-call-load-error {
  padding: 42px 24px;
  color: #d93026;
  line-height: 1.7;
  text-align: center;
}

.private-call-retry {
  margin-top: 18px;
}

.private-call-field {
  display: flex;
  align-items: center;
  margin: 16px 0;
}

.private-call-label {
  width: 72px;
  color: #666;
}

.private-call-order-value {
  flex: 1;
  min-width: 0;
  padding: 9px 2px;
  border-bottom: 1px solid #eee;
  color: #555;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.private-call-active,
.private-call-not-active {
  padding: 16px;
  border-radius: 8px;
  background: #fafafa;
  text-align: center;
}

.private-call-status {
  color: #52c41a;
  font-size: 14px;
}

.private-call-number {
  margin: 8px 0 4px;
  color: #fe5d42;
  font-size: 28px;
  font-weight: bold;
  letter-spacing: 1px;
}

.private-call-mask {
  margin-bottom: 12px;
  color: #666;
  font-size: 12px;
}

.private-call-tip {
  color: #888;
  font-size: 12px;
  line-height: 20px;
  text-align: left;
}

.private-call-actions {
  display: flex;
  justify-content: center;
  gap: 12px;
  margin-top: 16px;
}

.private-call-primary,
.private-call-danger {
  min-width: 108px;
  height: 34px;
  border-radius: 4px;
  cursor: pointer;
}

.private-call-primary {
  border: 1px solid #fe5d42;
  color: #fff;
  background: #fe5d42;
}

.private-call-danger {
  border: 1px solid #ddd;
  color: #666;
  background: #fff;
}

.private-call-create {
  margin-top: 0;
}

.private-call-consent {
  display: flex;
  align-items: flex-start;
  margin-top: 14px;
  padding: 12px;
  border-radius: 6px;
  color: #555;
  background: #f3f3f3;
  line-height: 20px;
  text-align: left;
  cursor: pointer;
}

.private-call-consent input {
  margin: 4px 9px 0 0;
  accent-color: #ed2616;
}

.private-call-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 16px;
}

.private-call-primary:disabled {
  border-color: #f0b4ad;
  background: #f0b4ad;
  cursor: not-allowed;
}

.title-text {
  font-family: PingFangSC-Medium;
  font-size: 15px;
  font-weight: normal;
  line-height: 18px;
  text-align: center;
  letter-spacing: 0px;
  color: #222222;
}

.send-button {
  position: absolute;
  right: 23px;
  bottom: 0px;
  width: 56px;
  height: 25px;
  border-radius: 4px;
  opacity: 1;
  background: #f7f7f7;
  box-sizing: border-box;
  border: 1px solid #dddddd;
  cursor: pointer;
}

.emobox {
  width: 100%;
  height: 105px;
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
}

.groupMembersBox{
  width: 100%;
}
.groupMembers{

}
.groupMembers:hover{
    background-color: rgba(237, 38, 22, 0.2);
    cursor: pointer;
}

.emobox::-webkit-scrollbar {
  width: 0 !important;
}

.emoitem {
  width: 25px;
  height: 25px;
  cursor: pointer;
  text-align: center;
  line-height: 25px;
  transition: all 0.3s ease;
  margin-right: 1px;
  margin-left: 0.5px;
  &:hover {
    transform: scale(1.2);
  }
}
.emoitemimg {
  width: 25px;
  height: 25px;
  cursor: pointer;
}

.image-box {
  width: 100px;
}

.audio-text {
  font-family: PingFangSCRegular-Regular;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #999999;
  margin-left: 8px;
}

.audio-text-my {
  font-family: PingFangSCRegular-Regular;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 0em;
  color: #999999;
  margin-left: 8px;
}

.imgheader {
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  position: relative;
}
/deep/ .ant-modal-body {
  padding: 16px;
}
.imgbox {
  display: flex;
  justify-content: center;
  height: 640px;
  align-items: center;
  position: relative;
  overflow: hidden;
}
.imgbox img {
  max-width: 80%;
  max-height: 640px;
  position: absolute;
  z-index: 10;
  user-select: none;
}
.imgaction {
  display: flex;
  justify-content: center;
  height: 40px;
  align-items: center;
  margin: auto;
}
.imgtitleaction {
  position: absolute;
  right: 16px;
  top: 0px;
}
.history {
  width: 260px;
  height: 100%;
  background-color: #fff;
  border-left: 1px solid #dddddd;
  flex-shrink: 0;
  /* 面板内内容异常超宽时裁在面板内，不许越界到窗口外 */
  overflow: hidden;
}
.custom-body {
  display: flex;
  justify-content: flex-start;
  margin-top: 8px;
  padding: 8px;
  border-radius: 5px 5px 5px 5px;
  background-color: #fff;
}
.custom-img {
  width: 60px;
  height: 60px;
}
.custom-img img {
  width: 60px;
  height: 60px;
  border-radius: 5px 5px 5px 5px;
}
.custom-text {
  height: 60px;
  width: 180px;
  margin-left: 8px;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}
.custom-name {
  width: 100px; /* 设置容器的宽度 */
  white-space: nowrap; /* 禁止文本换行 */
  overflow: hidden; /* 隐藏超出部分的内容 */
  text-overflow: ellipsis; /* 当文本溢出时显示省略号 */
}
.custom-action {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.custom-cel {
  border-radius: 20px;
  height: 29px;
  width: 100px;
  box-sizing: border-box;
}
.custom-ok {
  border-radius: 20px;
  height: 29px;
  font-size: 12px;
  opacity: 1;
  background: linear-gradient(90deg, #ff6044 0%, #ed2616 100%);
  box-shadow: 0px 8px 8px 0px rgba(237, 38, 22, 0.1);
  border: none;
  color: #fff;
}
.custom-ok-cleal {
  border-radius: 20px;
  font-size: 12px;
  height: 29px;
  opacity: 1;
  background: none;
  background-color: none;
  border: 1px solid #999;
}
.custom-ok-cleal:hover {
  border-radius: 20px;
  font-size: 12px;
  height: 29px;
  opacity: 1;
  background: none;
  background-color: none;
  border: 1px solid #999;
  color: #ed2616 !important;
}
.custom-ok-cleal:active {
  border-radius: 20px;
  font-size: 12px;
  height: 29px;
  opacity: 1;
  background: none;
  background-color: none;
  border: 1px solid #999;
  color: #ed2616;
}
.custom-ok-cleal:focus {
  border-radius: 20px;
  font-size: 12px;
  height: 29px;
  opacity: 1;
  background: none;
  background-color: none;
  border: 1px solid #ed2616;
  color: #ed2616;
}
.loadMore {
  font-size: 12px;
  color: #999999;
  margin-top: 10px;
  cursor: pointer;
}
.loadMoreh {
  color: blue;
}

.custom-price {
  color: #ed2616;
  font-weight: 600;
  margin-top: 2px;
}
.yqtext {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  flex-shrink: 0;
  font-size: 12px;
  line-height: 37px;
  margin-right: 10px;
  white-space: nowrap;
}

.yqtext:last-of-type {
  margin-right: 8px;
}
.imgdialog-order {
  border-radius: 10px;
  font-family: "PingFangSC-Regular";
}
.imgheader-order {
  font-weight: bold;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}
.imgbox-order {
  display: flex;
  justify-content: space-between;
  height: 640px;
}
.imgbox-order-left {
  width: 250px;
  border-right: 1px solid #eee;
}
.imgbox-order-right {
  height: 640px;
  width: 350px;
}

.login-input {
  border-radius: 4px;
  opacity: 1;
  box-sizing: border-box;
  border: 1px solid #d8d8d8;
  width: 220px;
  height: 29px;
  padding-left: 10px;
  padding-right: 10px;
  line-height: 29px;
  outline: none;
  color: #999;
}

.login-input:focus {
  outline: none;
  border: 1px solid #d8d8d8;
}

.login-input::placeholder {
  color: #999999;
}
.action-item {
  margin-top: 16px;
  margin-left: 0px;
  margin-right: 16px;
  position: relative;
  display: flex;
  justify-content: space-between;
  margin-bottom: 18px;
}
.seach-button {
  background-image: url('~@/assets/seach.png');
  background-size: 100%;
  width: 15px;
  height: 15px;
  position: absolute;
  top: 6px;
  left: 195px;
  cursor: pointer;
}
.z-tabs {
  display: flex;
  justify-content: flex-start;
}
.z-tab {
  border-radius: 60px;
  opacity: 1;
  background: rgba(136, 136, 136, 0.1);
  font-family: PingFang SC;
  font-size: 11px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0em;
  color: #222222;
  padding: 4px 10px;
  margin-right: 10px;
  cursor: pointer;
}
.z-tab-active {
  border-radius: 60px;
  opacity: 1;
  background: rgba(237, 38, 22, 0.1);
  font-family: PingFang SC;
  font-size: 11px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0em;
  color: #ed2616;
  padding: 4px 10px;
  margin-right: 10px;
  cursor: pointer;
}
.imbox-list {
  height: 540px;
  overflow-y: auto;
}
.plist-item {
  background: #f7f7f7;
  border-radius: 4px;
  height: 80px;
  margin-right: 16px;
  margin-top: 16px;
  padding: 10px;
  display: flex;
}
.item-image {
  width: 60px;
  height: 60px;
}
.item-image img {
  width: 60px;
  height: 60px;
  border-radius: 4px;
}
.item-body {
  margin-left: 10px;
  width: 130px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.item-body-name {
  font-size: 12px;
}
.item-body-desc {
  display: flex;
  justify-content: space-between;
}
.item-body-amount {
  font-size: 12px;
}
.item-body-button {
  font-size: 12px;
  border-radius: 60px;
  opacity: 1;
  background: rgba(136, 136, 136, 0.1);
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0em;
  color: #fff;
  padding: 4px 10px;
  cursor: pointer;
}
.item-body-button-active {
  font-size: 12px;
  border-radius: 60px;
  opacity: 1;
  background: rgba(237, 38, 22, 0.1);
  font-family: PingFang SC;
  font-size: 12px;
  font-weight: normal;
  line-height: 17px;
  letter-spacing: 0em;
  color: #ed2616;
  padding: 4px 10px;
  cursor: pointer;
}
.right-title {
  height: 50px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  padding: 15px 10px;
}
.right-title-action {
  color: #ed2616;
}
.select-list {
  height: 560px;
}
.right-foot {
  height: 50px;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  padding-left: 10px;
}
.right-foot-num {
  font-size: 12px;
  margin-top: 10px;
}
.right-foot-amount {
  font-size: 12px;
  margin-top: 10px;
  margin-right: 80px;
}
.right-foot-button {
  width: 80px;
  height: 36px;
  opacity: 1;
  background: #ed2616;
  border-bottom-right-radius: 4px;
  font-size: 14px;
  text-align: center;
  color: #fff;
  line-height: 36px;
  position: absolute;
  bottom: 0px;
  right: 0px;
  cursor: pointer;
}
.select-item {
  margin-left: 10px;
  margin-top: 10px;
}
.select-image {
  width: 100px;
  height: 100px;
  border-radius: 10px;
  margin-left: 10px;
}
.select-image img {
  width: 100px;
  height: 100px;
  border-radius: 10px;
}
.select-image-icon {
  margin-top: 40px;
}
.box-select {
  border: none;
  width: 120px;
  outline: none;
}
.box-select::focus {
  border: none;
  width: 80px;
}
.box-input {
  border: 1px solid #eee;
  width: 50px;
  outline: none;
  text-align: center;
}
.box-input::focus {
  border: none;
  width: 80px;
}
.context-menu {
  position: fixed;
  background-color: #fff;
  list-style-type: none;
  padding: 4px;
  border: 1px solid #ccc;
  border-radius: 10px;
  z-index: 999;
}
.context-menu li {
  padding: 4px 12px;
  cursor: pointer;
  display: flex;
  font-size: 14px;
  color: #222;
  border-radius: 5px;
  background-color: #fff;
}
.context-menu li:hover {
  background: rgba(237, 38, 22, 0.05);
}
.forward-plant {
  background-color: #fff;
  border-top: 1px solid #eee;
  height: 122px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.forward-item {
  margin-top: 20px;
  margin-right: 72px;
}
.z-forward-pc {
  width: 44px;

  height: 44px;
}
.h-forward-pc {
  width: 44px;
  height: 44px;
}
.down-pc {
  width: 44px;
  height: 44px;
}
.close-pc {
  width: 16px;
  height: 16px;
}
.forward-txt {
  font-size: 14px;
  color: #222;
  margin-top: 8px;
  align-items: center;
}
/* 批量下载禁用态：置灰文字并挡住点击，可用态由 hasDownloadableSelected 控制换图标 */
.forward-item-disabled {
  pointer-events: none;
}
.forward-item-disabled .forward-txt {
  color: #bbb;
}
.quote-plant {
  position: absolute;
  width: 100%;
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  border-left: 4px solid #d8d8d8;
  align-items: center;
  padding-left: 4px;
  padding-right: 10px;
}
.quote-text {
  margin-left: 8px;
  text-align: left;
  font-size: 12px;
  color: #666;
  padding-top:8px ;
  padding-bottom: 8px;
  font-family: "PingFang SC";
  /* 长数字/无空格串换行，防止撑破引用弹窗 */
  word-break: break-all;
  overflow-wrap: anywhere;
}
.quote-body {
  padding-left: 8px;
  text-align: left;
  font-size: 12px;
  color: #666;
  border-left: 4px solid #d8d8d8;
  margin-bottom: 8px;
}
.forward-dailog {
  border-radius: 10px;
  display: flex;
}
.forward-left {
  width: 216px;
  background-color: #fff;
  border-right: 1px solid #eee;
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom-left-radius: 10px;
  border-top-left-radius: 10px;
}
.forward-search {
  border-radius: 5px;
  background-color: #eee;
  margin-left: 16px;
  margin-right: 16px;
  padding: 4px 8px 4px 8px;
  display: flex;
  align-items: center;
}
.forward-search-icon {
  width: 15px;
  height: 15px;
}
.forward-search-input {
  margin-left: 6px;
  color: #9c9c9c;
  font-size: 12px;
  border: none;
  background-color: #eee;
  outline: none;
  width: 180px;
}

.forward-desc {
  margin-top: 16px;
  margin-left: 16px;
  margin-right: 16px;
  color: #444;
  font-size: 12px;
}
.forward-session-list {
  margin-top: 8px;
  height: 300px;
  overflow-y: auto;
}
.forward-session-item {
  padding: 8px 18px 8px 18px;
  display: flex;
  align-items: center;
}
.forward-session-item:hover {
  background-color: rgba(237, 38, 22, 0.05);
}
.forward-session-icon {
  width: 14px;
  height: 14px;
}
.forward-session-avatar {
  width: 28px;
  height: 28px;
  border: 1px solid #979797;
  margin-left: 8px;
  border-radius: 50%;
}
.forward-session-nickname {
  color: #222;
  font-size: 10px;
  margin-left: 6px;
}
.forward-right {
  width: 256px;
  background-color: #fff;
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom-right-radius: 10px;
  border-top-right-radius: 10px;
}
.forward-right-title {
  margin-left: 16px;
  margin-right: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.forward-right-text {
  color: #222;
  font-size: 14px;
}
.forward-message {
  height: 30px;
  margin-left: 16px;
  margin-right: 16px;
  border-left: 4px solid #d8d8d8;
  padding-left: 12px;
  padding-right: 10px;
  padding-top: 6px;
  padding-bottom: 6px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #f8f8f8;
  margin-top: 16px;
}
.forward-message-text {
  color: #666;
  font-size: 12px;
}
.forward-message-input-bg {
  margin-left: 16px;
  margin-right: 16px;
  height: 29px;
  border-radius: 6px;
  box-sizing: border-box;
  border: 1px solid #cccccc;
  padding: 0px 10px 0px 10px;
  background-color: #fff;
  margin-top: 16px;
  display: flex;
  align-items: center;
}
.forward-message-input {
  color: #9c9c9c;
  font-size: 12px;
  border: none;
  background-color: #fff;
  outline: none;
  width: 180px;
}
.forward-message-buttons {
  margin-left: 16px;
  margin-right: 16px;
  margin-top: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.forward-message-button-calce {
  width: 108px;
  height: 31px;
  border-radius: 4px;
  background: #eeeeee;
  font-size: 12px;
  color: #222222;
  border: none;
}
.forward-message-button-ok {
  width: 108px;
  height: 31px;
  border-radius: 4px;
  background: #ed2616;
  font-size: 12px;
  color: #fffdfd;
  border: none;
}
/deep/ .ant-modal-content {
  border-radius: 10px;
}
.f-m-title {
  margin: 16px;
  margin-top: 0px;
  padding-top: 16px;
  display: flex;
  justify-content: space-between;
}
.f-m-t-text {
  font-size: 16px;
  color: #222;
  font-weight: 600;
}
.f-m-time {
  height: 30px;
  box-shadow: inset 0px 1px 0px 0px #eeeeee;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
.f-m-list {
  height: 664px;
  overflow-y: auto;
  margin-left: 24px;
  margin-right: 24px;
}
.f-m-line {
  height: 46px;
  border-top: 1px solid #eee;
  margin-left: 24px;
  margin-right: 24px;
}
.f-m-item {
  padding-top: 16px;
  padding-bottom: 16px;
  border-bottom: 1px solid #eee;
}
.f-m-i-title {
  display: flex;
}
.f-m-i-t-text {
  font-size: 13px;
  color: #666;
}
.f-m-i-t-time {
  font-size: 13px;
  color: #666;
  margin-left: 8px;
}
.f-m-i-body-text {
  font-size: 14px;
  color: #222;
}
.f-m-i-body-file {
  width: 243px;
  display: flex;
  border-radius: 10px;
  background: #fafafa;
  border: 1px solid rgba(34, 34, 34, 0.1);
  padding: 10px;
}
.f-m-i-body-f-left {
}
.f-m-i-body-f-l-text {
  color: #222;
  font-size: 16px;
}
.f-m-i-body-f-l-desc {
  color: #888;
  font-size: 12px;
  margin-top: 6px;
}
.f-m-i-body-f-img {
  width: 50px;
  height: 50px;
}
.f-m-i-body-img {
  max-width: 260px;
  border-radius: 5px;
}
.jiabian {
  padding: 4px 6px 4px 6px;
  font-size: 12px;
}

.note-right {
  width: 12px;
  height: 12px;
}
.note-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10rpx;
  border-top: 1px solid #eee;
  padding-top: 10px;
}
.note-button {
  color: #888;
  font-size: 10px;
}
.note-title {
  color: #222;
  font-weight: 600;
  font-size: 16px;
}
.note-content {
  color: #888;
  font-size: 12px;
  margin-top: 4px;
}

.mb {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 9;
}
.demand-body{
  font-family: "PingFangSC-Regular";
  border: none;
  font-weight: 500;
}
.demand-item{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 16px;
}
.demand-title{
  width: 200px;
  font-size: 14px;
  color:#666;
}
.demand-desc{
  font-size: 14px;
  color:#222;
}
.demand-line{
  height: 1px;
  width: 100%;
  background-color:#eee;
  margin-bottom: 16px;
}
.demand-tab{
  display: flex;
  justify-items: flex-start;
  align-items: center;
  overflow-y: auto;

  height: 40px;
}
.demand-tab-item{
  font-size: 14px;
  color:#666;
  margin-right: 24px;
  position: relative;
}
.demand-tab .active {
  color:#ED2616;
}
.demand-tab .active:after {
  content: '';
  height: 3px;
  position: absolute;
  width: 100%;
  bottom: -8px;
  left: 0px;
  background: rgba(237, 38, 22, 1);
}
.demand-body{
  margin-top: 16px;
}
.demand-body-item{
  display: flex;
  align-items: center;
}
</style>

<style lang="less">
/* el-image 大图预览(查看图片)的关闭按钮：聊天窗顶部 73px 是 -webkit-app-region: drag
   拖拽区，Electron 下 drag 区吞掉所有点击(点 × 实际变成拖动窗口，无论 z-index 多高)，
   原 top:15px 恰好落在拖拽区内——这就是"点×关不掉、点黑色遮罩才能关"的根因。
   故按钮下移避开拖拽区，并放大热区便于点击 */
.el-image-viewer__close {
  top: 92px !important;
  right: 30px !important;
  width: 56px !important;
  height: 56px !important;
  font-size: 40px !important;
  color: #ffffff !important;
  background-color: rgba(0, 0, 0, 0.35);
  border-radius: 50%;
}
.el-image-viewer__close:hover {
  background-color: rgba(0, 0, 0, 0.55);
}

/* 拖拽发送遮罩：拖文件进窗口时全窗提示 */
.drop-mask {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  border: 3px dashed #1890ff;
  box-sizing: border-box;
}
.drop-mask-text {
  background: #1890ff;
  color: #fff;
  font-size: 16px;
  padding: 12px 28px;
  border-radius: 8px;
}
.rd-title { font-size: 16px; font-weight: 600; margin-bottom: 12px; }
.rd-card { display: flex; align-items: flex-start; background: #f7f7f7; border-radius: 8px; padding: 10px; }
.rd-avatar { width: 40px; height: 40px; border-radius: 50%; margin-right: 10px; object-fit: cover; }
.rd-card-main { flex: 1; min-width: 0; }
.rd-row { display: flex; justify-content: space-between; color: #888; font-size: 12px; }
.rd-time { color: #bbb; }
.rd-msg { margin-top: 6px; color: #222; font-size: 14px; }
.rd-tabs { display: flex; margin: 16px 0 8px; }
.rd-tab { width: 50%; text-align: center; color: #888; cursor: pointer; }
.rd-tab.on { color: #222; font-weight: 600; }
.rd-line { width: 28px; height: 3px; background: #ed2616; margin: 8px auto 0; }
.rd-list { max-height: 320px; overflow: auto; }
.rd-item { display: flex; align-items: center; padding: 10px 0; border-bottom: 1px solid #f2f2f2; }
.rd-item img { width: 36px; height: 36px; border-radius: 50%; margin-right: 10px; object-fit: cover; }

</style>
